export const portalPageCopy = {
  en: {
    shared: {
      featureUnavailable: 'This feature is not enabled',
      featureUnavailableDetail: 'To add this feature, please contact a Bizsprite partner or contact us directly.',
      loadingPanel: 'Loading customer panel',
      checkingAccess: 'Checking tenant access...',
    },
    settings: {
      pageTitle: 'Company Info & AI Settings',
      pageDescription: 'Configure your company profile and AI assistant settings',
      profileStep: 'Company profile',
      profileStepDescription: 'Basic details callers and the AI rely on.',
      voiceStep: 'Greeting & voice',
      voiceStepDescription: 'Choose how the AI starts and sounds.',
      contextStep: 'Context & timezone',
      contextStepDescription: 'Add business context and time handling.',
      importCsv: 'Import CSV',
      downloadTemplate: 'Download Template',
      companyName: 'Company Name',
      companyPhone: 'Company Phone',
      companyAddress: 'Company Address',
      welcomeMessage: 'Welcome Message',
      welcomeHelp: 'The first message callers hear when they connect. Keep it friendly and concise.',
      welcomePlaceholder: 'e.g. Hello, thank you for calling. How can I help you today?',
      welcomeMissing: 'Not configured — the AI will fall back to a generic greeting until you save one here.',
      aiVoice: 'AI Voice',
      voiceHelp: 'Choose the voice for your AI assistant. Use Test Voice to preview before saving.',
      voicePlaceholder: 'Not configured — pick a voice',
      testVoice: 'Test Voice',
      companyContext: 'Company Context for AI',
      companyContextHelp: 'Provide background about your company to help the AI assistant understand your business. Include your industry, services offered, common customer questions, or any context that helps the AI respond accurately to callers.',
      companyContextExamples: 'Examples: “We are a dental clinic specializing in family dentistry and cosmetic procedures” or “IT consulting firm providing cloud migration, cybersecurity, and managed services”',
      companyContextPlaceholder: 'Describe your company, services, and common caller needs...',
      timezone: 'Timezone',
      timezoneHelp: 'Used for time-based greetings and call history display. Booking timezone rules are configured in Scheduling.',
      timezonePlaceholder: 'Not configured — pick a timezone',
      applyTimezone: 'Apply',
      back: 'Back',
      moreSettings: 'More settings below',
      step: 'Step',
      of: 'of',
      continue: 'Continue',
      saveContinue: 'Save & Continue',
      saveFinish: 'Save & Finish',
      settingsSaved: 'Settings saved',
      settingsSavedDetail: 'AI context and display timezone are up to date.',
      timezoneSetFromAddress: 'Timezone set from address',
      appliedTimezone: 'Applied',
      noTenantId: 'No tenant ID available',
      noTenant: 'No tenant',
      companyInfoSaved: 'Company information saved',
      companyInfoSaveFailed: 'Failed to save company info',
      importFailed: 'Import failed',
      noCsvRows: 'No rows found in CSV',
      companyInfoImported: 'Company info imported',
      saveImportedCompanyInfo: 'Use Save & Continue to save this step.',
      aiSettingsSaved: 'AI settings saved',
      aiSettingsSaveFailed: 'Failed to save AI settings',
      voiceSettingsUpdated: 'Voice settings updated',
      saveVoiceSettingsHelp: 'Use the step save button to apply changes.',
      goToStep: 'Go to',
    },
    scheduling: {
      pageTitle: 'Scheduling',
      pageSummary: 'Manage booking pages, availability, events, and records.',
      filtering: 'Filtering',
      selectedAccount: 'Selected account',
      calendarDisplay: 'Calendar display',
      displayTooltip: 'Only changes how times are displayed in this workspace. It does not change booking availability or resource timezones.',
      helpDescription: 'Connect calendars, define appointment types, set availability, and review booking records from one workspace.',
      connectCalendars: 'Connect calendars',
      connectCalendarsDetail: 'Link Google, Apple, Calendly, or Teams from the sidebar.',
      createAppointmentTypes: 'Create appointment types',
      createAppointmentTypesDetail: 'Define what customers can book and where those bookings should land.',
      setAvailability: 'Set availability',
      setAvailabilityDetail: 'Tune weekly hours, buffers, daily caps, and date-specific exceptions.',
      reviewRecords: 'Review records',
      reviewRecordsDetail: 'Monitor confirmed bookings, sync failures, and conflict alerts in one tab.',
      connectedCalendars: 'Connected Calendars',
      bookingTimezoneTitle: 'Booking timezone behavior',
      bookingTimezoneHelp: "A booking resource connects its location, calendar account, booking page, and timezone. Single timezone uses one booking timezone; multiple timezones use each resource's configured location and timezone.",
      mode: 'Mode',
      singleTimezone: 'Single timezone',
      multipleTimezones: 'Multiple resource timezones',
      bookingTimezone: 'Booking timezone',
      fallbackTimezone: 'Fallback timezone',
      saveBookingTimezone: 'Save booking timezone',
      noTenant: 'No tenant ID available',
      saved: 'Booking timezone settings saved',
      saveFailed: 'Failed to save booking timezone settings',
      openConnections: 'Open connections',
      bookingPageTab: 'Booking Page',
      availabilityTab: 'Availability',
      eventsTab: 'Calendar Events',
      recordsTab: 'Records',
      overviewTab: 'Overview',
      all: 'All',
      minutes: 'min',
      save: 'Save',
      cancel: 'Cancel',
      edit: 'Edit',
      delete: 'Delete',
      editService: 'Edit service',
      deleteService: 'Delete service',
      serviceName: 'Service name',
      add: 'Add',
      serviceTypes: 'Service Types',
      serviceTypesHelp: 'Define the service names and durations customers can choose from.',
      addService: 'Add service',
      noServiceTypes: 'No service types yet',
      noServiceTypesHelp: 'Add at least one so customers can book this page.',
      serviceTypeCount: 'service types',
      serviceTypeCountSingle: 'service type',
      maxPerDay: 'Max',
      perDay: 'day',
      configureSchedule: 'Configure schedule',
      settings: 'Settings',
      deleteBookingPage: 'Delete booking page',
      schedule: 'Schedule',
      noSchedule: 'No recurring schedule configured yet',
      targetCalendar: 'Target Calendar',
      noTargetCalendar: 'No target calendar selected',
      location: 'Location',
      deleteBookingTitle: 'Delete booking page?',
      deleteBookingBody: 'This removes the booking page and its service types from the workspace.',
      bookingPages: 'Booking Pages',
      bookingPagesQuestion: 'What can customers book, and where do those bookings go?',
      newBookingPage: 'New Booking Page',
      noBookingPages: 'No booking pages yet',
      noBookingPagesHelp: 'Create your first booking page to start accepting bookings.',
      createBookingPage: 'Create Booking Page',
      updateServiceFailed: 'Failed to update service',
      createServiceFailed: 'Failed to create service',
      deleteServiceFailed: 'Failed to delete service',
      deleteFailed: 'Failed to delete',
      bookingPageUpdated: 'Booking page updated',
      bookingPageCreated: 'Booking page created',
      saveFailedGeneric: 'Failed to save',
      bookingPageDeleted: 'Booking page deleted',
      deleteServiceConfirm: 'Delete this service option?',
      setupRequired: 'Setup Required',
      noCalendars: 'No calendars connected',
      noCalendarsHelp: 'Connect at least one calendar account before creating appointment types, syncing events, and reviewing booking records.',
      connectCalendar: 'Connect Calendar',
      scheduleUpdated: 'Schedule updated',
      availabilityNoPagesHelp: 'Create a booking page first, then manage its availability here.',
      availabilitySummary: 'Weekly hours, exceptions, buffers, and booking limits.',
      calendar: 'Calendar',
      exception: 'exception',
      exceptions: 'exceptions',
      weeklyHours: 'Weekly Hours',
      noWeeklySchedule: 'No recurring weekly schedule has been set yet.',
      rules: 'Rules',
      buffer: 'Buffer',
      unlimitedDaily: 'Unlimited daily bookings',
      editHours: 'Edit hours',
      allCalendars: 'All calendars',
      selectedAccountOption: 'Selected account',
      eventsSummary: 'Review synced events and add manual calendar entries when needed.',
      allDay: 'All day',
      previousMonth: 'Previous month',
      nextMonth: 'Next month',
      newAppointment: 'New Appointment',
      weekdaysShort: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
      more: 'more',
      editEvent: 'Edit event',
      deleteEvent: 'Delete event',
      noEvents: 'No events this month.',
      deleteAppointmentFailed: 'Failed to delete appointment',
      eventUpdated: 'Event updated',
      appointmentCreated: 'Appointment created',
      updateEventFailed: 'Failed to update event',
      createAppointmentFailed: 'Failed to create appointment',
      overviewSummary: 'Connection health, booking health, and what needs attention.',
      connectedCalendarsMetric: 'Connected Calendars',
      activeCount: 'active',
      visibleCurrentFilter: 'Visible in the current filter',
      lastSync: 'Last Sync',
      never: 'Never',
      syncingNow: 'Syncing now',
      syncStaleHelp: 'Use sync if events look stale',
      connectionHealth: 'Connection Health',
      calendarConnections: 'Calendar connections',
      connectionHealthHelp: 'Healthy connections keep availability and synced events trustworthy.',
      activeAccountsView: 'active accounts are currently powering this view.',
      activeAccountView: 'active account is currently powering this view.',
      noCalendarsYet: 'No calendars are connected yet.',
      syncNow: 'Sync now',
      bookingHealth: 'Booking Health',
      currentBookingStatus: 'Current booking status',
      bookingHealthHelp: 'The counts below show whether bookings are flowing normally.',
      confirmed: 'Confirmed',
      pending: 'Pending',
      syncFailed: 'Sync Failed',
      attention: 'Attention',
      whatNeedsReview: 'What needs review',
      attentionHelp: 'Use this to see whether anything should pull you into Records.',
      noUrgentIssues: 'No urgent issues are visible right now.',
      unresolvedConflicts: 'unresolved conflicts',
      failedSyncRecords: 'records failed to sync',
      pendingBookingRecords: 'pending booking records',
      recordsSummary: 'Resolve issues first, then browse the full booking history.',
      attentionNeeded: 'Attention Needed',
      affectedBookings: 'affected bookings',
      syncFailures: 'sync failures',
      conflictRecords: 'conflict records',
      searchRecords: 'Search by customer, service, or booking ID…',
      allRecords: 'All Records',
      noBookingRecords: 'No booking records yet',
      noBookingMatches: 'No bookings match this filter',
      bookingRecordsHelp: 'Once customers start booking, confirmations, pending holds, failures, and conflicts will appear here.',
      filterNoMatchHelp: 'Try a different filter or clear the search.',
      clearFilters: 'Clear filters',
      advancedRetry: 'Advanced: Manual Retry by ID',
      pasteBookingId: 'Paste booking ID',
      retrySync: 'Retry Sync',
      syncRetried: 'Sync retried',
      retryFailed: 'Retry failed',
      bookingCancelled: 'Booking cancelled',
      cancelFailed: 'Failed to cancel',
      cancelled: 'Cancelled',
      copied: 'Copied',
      conflict: 'Conflict',
      synced: 'Synced',
      conflictAttached: 'Conflict attached',
      syncStatus: 'Sync',
      bookingLabel: 'Booking',
      externalEvent: 'External event',
      bookingPageLabel: 'Booking page',
      serviceTypeLabel: 'Service type',
      bookingReference: 'Booking ref',
      failureReason: 'Failure reason',
      bookingId: 'Booking ID',
      requestId: 'Request ID',
      unresolved: 'Unresolved',
      bookingStatuses: {
        confirmed: 'Confirmed',
        tentative: 'Tentative',
        pending: 'Pending',
        hold: 'On hold',
        conflict: 'Conflict',
        expired: 'Expired',
        cancelled: 'Cancelled',
        unknown: 'Unknown',
      },
      syncStatuses: {
        synced: 'Synced',
        pending: 'Pending',
        failed: 'Failed',
      },
      conflictResolutions: {
        unresolved: 'Unresolved',
        auto_resolved: 'Automatically resolved',
        manual: 'Manually resolved',
        ignored: 'Ignored',
      },
      cancelBookingTitle: 'Cancel booking?',
      cancelBookingBody: 'This booking will be marked as cancelled and removed from active scheduling.',
      keepBooking: 'Keep booking',
      cancelBooking: 'Cancel booking',
      copyBookingId: 'Copy booking ID',
      copyRequestId: 'Copy request ID',
      details: 'Details',
      less: 'Less',
      conflictsNeedAttention: 'unresolved conflicts need attention',
      customerUnavailable: 'Customer details unavailable',
      syncing: 'Syncing…',
      syncAll: 'Sync all',
      syncAllAccounts: 'Sync all accounts',
      allAccounts: 'All Accounts',
      noAccounts: 'No accounts connected yet.',
      hideConnectionSetup: 'Hide connection setup',
      connectAccount: 'Connect account',
      providerLimit: 'You have reached the current limit for this provider.',
      editLabel: 'Edit label',
      recheckCapability: 'Re-check capability',
      recheck: 'Re-check',
      disconnect: 'Disconnect',
      disconnectCalendarTitle: 'Disconnect calendar?',
      disconnectCalendarPrefix: 'Disconnect',
      disconnectCalendarSuffix: 'Existing records stay visible, but new syncs will stop.',
      editPrefix: 'Edit',
      bookingPageDetails: 'Booking Page Details',
      bookingPageDetailsHelp: 'Edit the customer-facing details for this booking page. Availability is managed separately in the Availability tab.',
      titleField: 'Title',
      bookingTitlePlaceholder: 'e.g. Business Consultation',
      bookingDestination: 'Booking Destination',
      selectCalendar: 'Select a calendar…',
      primary: 'Primary',
      timezoneField: 'Timezone',
      locationPlaceholder: 'e.g. New York Office',
      allowGuests: 'Allow guests to invite others',
      allowGuestsHelp: 'Keep this on only when extra attendees should be able to join the appointment.',
      saveBookingPage: 'Save Booking Page',
      editEventTitle: 'Edit Event',
      localCalendar: 'Local calendar',
      disconnected: 'disconnected',
      titleRequired: 'Title is required',
      startRequired: 'Start is required',
      endRequired: 'End is required',
      endAfterStart: 'End time must be after start time',
      appointmentTitlePlaceholder: 'Enter appointment title',
      descriptionField: 'Description',
      optionalDescription: 'Optional description',
      startField: 'Start',
      endField: 'End',
      calendarAccount: 'Calendar account',
      updateEvent: 'Update Event',
      createAppointment: 'Create Appointment',
      availabilitySuffix: 'availability',
      availabilityRules: 'Availability Rules',
      availabilityRulesHelp: 'Edit recurring availability, buffers, daily caps, and date-specific exceptions for this booking page.',
      weeklySchedule: 'Weekly Schedule',
      weekdaysLong: { mon: 'Monday', tue: 'Tuesday', wed: 'Wednesday', thu: 'Thursday', fri: 'Friday', sat: 'Saturday', sun: 'Sunday' },
      unavailable: 'Unavailable',
      removeSlot: 'Remove slot',
      addSlot: 'Add slot',
      copyToAll: 'Copy to all',
      schedulingPolicy: 'Scheduling Policy',
      bufferBefore: 'Buffer Before (min)',
      bufferAfter: 'Buffer After (min)',
      dailyMaxBookings: 'Daily Max Bookings',
      zeroUnlimited: '0 = unlimited',
      zeroMeansUnlimited: '0 means unlimited',
      exceptionsHelp: 'Add holidays, closures, or one-off availability overrides.',
      addException: 'Add Exception',
      noExceptions: 'No exceptions configured.',
      closedAllDay: 'Closed all day?',
      removeException: 'Remove exception',
      addTimeSlot: 'Add time slot',
      saveAvailability: 'Save Availability',
      connectAppleTitle: 'Connect Apple Calendar',
      connectAppleHelp: 'Use your Apple ID and an app-specific password from appleid.apple.com. Two-factor authentication must be enabled.',
      appleId: 'Apple ID',
      appleIdRequired: 'Apple ID is required',
      appPassword: 'App-specific Password',
      appPasswordRequired: 'App-specific password is required',
      connect: 'Connect',
      activeDays: 'active days',
    },
    qa: {
      pageTitle: 'QA Knowledge',
      pageDescription: 'Maintain customer-facing answers, answer boundaries, and support-ticket handoff rules.',
      helpFind: 'Find the customer issue',
      helpFindDetail: 'Search by question, answer, category, platform, required information, ticket fields, or risk notes.',
      helpPolicy: 'Set what AI may do',
      helpPolicyDetail: 'Direct means answer now. Collect info first means ask before concluding. No direct answer means route to support.',
      helpHandoff: 'Make handoff easy',
      helpHandoffDetail: 'When a row needs human support, turn on ticket creation and list the fields support must receive.',
      policySummary: 'Policy Summary',
      total: 'total',
      active: 'Active',
      review: 'Review',
      tickets: 'Tickets',
      needsAttention: 'Needs attention',
      currentList: 'Current list',
      visible: 'visible',
      loaded: 'loaded',
      search: 'Search QA...',
      allStatuses: 'All statuses',
      draft: 'Draft',
      needReview: 'Need Review',
      disabled: 'Disabled',
      allModes: 'All modes',
      direct: 'Direct',
      conditional: 'Conditional',
      noDirect: 'No direct answer',
      allCategories: 'All categories',
      allPlatforms: 'All platforms',
      clearFilters: 'Clear filters',
      createTooltip: 'Create a new QA pair',
      exportTooltip: 'Download current QA as a structured XLSX workbook',
      importTooltip: 'Upload an edited CSV template, structured FAQ DOCX, or structured QA XLSX',
      new: 'New',
      export: 'Export',
      import: 'Import',
      loading: 'Loading QA pairs',
      refreshing: 'Refreshing QA pairs',
      ticket: 'Ticket',
      needInfo: 'Need info',
      needFields: 'Need fields',
      needPath: 'Need path',
      needs: 'Needs',
      noMatches: 'No matching QA pairs.',
      noRows: 'No QA pairs.',
      backToList: 'Back to QA list',
      editorTitle: 'QA editor',
      editorDescription: 'Edit what the AI can say, when it needs more information, and when support should follow up.',
      customerQuestion: 'Customer question',
      customerQuestionHelp: 'The customer wording or trigger scenario. Keep it close to how customers actually ask.',
      questionNewPlaceholder: 'Example: Will this case fit my device?',
      questionPlaceholder: 'Select or create a QA',
      category: 'Category',
      categoryHelp: 'Group related questions so support can scan and filter quickly.',
      categoryPlaceholder: 'Product Compatibility',
      standardAnswer: 'Standard answer',
      standardAnswerHelp: 'The approved answer. The AI may rewrite or translate it, but should not invent facts outside this content.',
      answerNewPlaceholder: 'Approved answer the AI can use.',
      answerPlaceholder: 'The answer will appear here',
      answerMode: 'Answer mode',
      answerModeHelp: 'Direct answers immediately. Collect info first asks for required details. No direct answer sends the issue to support.',
      directAnswer: 'Direct answer',
      collectFirst: 'Collect info first',
      status: 'Status',
      statusHelp: 'Only Active rows are used by realtime AI answers. Use Need Review or Draft when the row is not ready.',
      createTicket: 'Create support ticket',
      createTicketHelp: 'Turn this on when support should receive a ticket for this scenario.',
      requiredInfo: 'Required info',
      requiredInfoHelp: 'List the information AI must collect before answering a Conditional row.',
      requiredInfoPlaceholder: 'Device brand; full model; order number...',
      riskNotes: 'Risk notes',
      riskNotesHelp: 'Hard limits for the AI. Put refund, replacement, official authorization, and 100% fit restrictions here.',
      riskNotesPlaceholder: 'Do not promise refund, compensation, or 100% fit.',
      escalationTrigger: 'Escalation trigger',
      escalationHelp: 'Describe the moment when the AI should stop trying to answer and hand off to support.',
      escalationPlaceholder: 'Model unclear, refund requested...',
      ticketFields: 'Ticket fields',
      ticketFieldsHelp: 'Fields support needs in the generated ticket. Use the shortcuts below to add common fields.',
      ticketFieldsPlaceholder: 'Order number; product; issue; phone...',
      showAdvanced: 'Show advanced details',
      hideAdvanced: 'Hide advanced details',
      readinessWarning: 'Active QA readiness warning',
      dangerZone: 'Danger Zone',
      deleteQa: 'Delete QA',
      save: 'Save',
      cancel: 'Cancel',
      maintenanceTitle: 'Template Maintenance',
      maintenanceDescription: 'Download the current QA as a structured XLSX workbook, edit it, then upload it back. Existing rows update by QA id or matching question. The workbook preserves answer mode, required info, escalation, ticket fields, risk notes, status, platform, and template dictionaries.',
      maintenanceContract: 'CSV columns: qa_id, question, answer, source, language. Structured XLSX imports preserve workbook dictionaries; Draft, Need Review, and Disabled rows are not used for realtime answers.',
      lastImport: 'Last import result',
      exportXlsx: 'Export XLSX',
      exportCsv: 'Export CSV',
      importFile: 'Import File',
      close: 'Close',
      deleteTitle: 'Delete Confirmation',
      deleteBody: 'Are you sure? This action cannot be undone.',
      delete: 'Delete',
      workbookGuide: 'Workbook guide',
      structuredTemplate: 'Structured QA template',
      workbookGuardrail: 'Use this as a guardrail: write what AI may answer, what it must collect, and when it should create a ticket.',
      loadedState: 'Loaded',
      expectedState: 'Expected',
      keyRule: 'Key rule',
      rule: 'Rule',
      commonTicketFields: 'Common ticket fields',
      rowChecks: 'Row checks',
      rowChecksHelp: 'Only missing workbook fields are shown here.',
      ready: 'Ready',
      qaId: 'QA ID',
      qaIdHelp: 'Template row ID. Useful for workbook sync, but not needed for most daily edits.',
      qaIdPlaceholder: 'CP-005 / CUSTOM-001',
      owner: 'Owner',
      ownerHelp: 'Internal owner for follow-up or review.',
      ownerPlaceholder: 'Support / Operations',
      keywords: 'Keywords / intent',
      keywordsHelp: 'Optional intent words used for search and matching.',
      keywordsPlaceholder: 'fit, compatible, device model…',
      platform: 'Platform',
      platformHelp: 'Where this QA applies. Examples include marketplace, website, or phone.',
      platformPlaceholder: 'Marketplace / Website / Phone',
      source: 'Source',
      sourceHelp: 'Where this QA came from.',
      sourcePlaceholder: 'Structured QA template, manual…',
      language: 'Language',
      languageHelp: 'Language tag for legacy compatibility.',
      languagePlaceholder: 'en, zh, es…',
      templateGaps: 'Template gaps',
      conditionalMissingRequiredInfo: 'Conditional answer is missing required info.',
      escalationMissingTicketFields: 'Support-ticket escalation is missing ticket fields.',
      noDirectMissingEscalation: 'No-direct-answer row has no escalation path.',
      templateFieldLabels: {
        template_qa_id: 'QA ID', category: 'Category', question: 'Customer question',
        answer: 'Approved answer', keywords: 'Keywords', required_info: 'Required info',
        answer_mode: 'Answer mode', should_escalate: 'Support ticket',
        escalation_trigger: 'Escalation trigger', ticket_fields: 'Ticket fields',
        risk_notes: 'Risk notes', platform: 'Platform', status: 'Status',
        owner: 'Owner', source: 'Source',
      },
      importApplied: 'applied',
      createdRows: 'created',
      updatedRows: 'updated',
      skippedRows: 'skipped',
      draftRows: 'draft',
      indexedRows: 'indexed',
      importedQas: 'Imported QAs:',
      policyWarnings: 'policy warnings',
      missingRequiredInfoCount: 'missing required info',
      missingTicketFieldsCount: 'missing ticket fields',
      noDirectNoEscalationCount: 'no-direct rows without escalation',
      reviewImportedRows: 'review imported rows',
      metadataSaved: 'metadata saved',
      metadataNotSaved: 'metadata not saved',
      sheetsLabel: 'sheets',
      deletedToast: 'QA pair deleted',
      deleteFailedToast: 'Delete failed',
      questionRequired: 'Question is required',
      answerRequired: 'Answer is required',
      createdToast: 'QA created',
      updatedToast: 'QA updated',
      apiErrorToast: 'API error',
      uploadFailedToast: 'Upload failed',
      csvDownloadedToast: 'Current QA CSV downloaded',
      downloadFailedToast: 'Download failed',
      xlsxDownloadedToast: 'Structured QA XLSX downloaded',
      xlsxFailedToast: 'Structured XLSX download failed',
    },
    products: {
      pageTitle: 'Product Info',
      pageDescription: 'Keep product facts current and review support suggestions when needed.',
      downloadTemplate: 'Download Template',
      exportCurrent: 'Export Current Data',
      uploadFile: 'Upload Product File',
      totalSkus: 'Total SKUs',
      activeSkus: 'Active SKUs',
      pendingReview: 'Pending Review',
      lastImport: 'Last Import',
      suggestionsNeedReview: 'product support suggestions need review.',
      suggestionNeedsReview: 'product support suggestion needs review.',
      reviewSuggestions: 'Review Suggestions',
      productsTab: 'Products',
      importsTab: 'Imports',
      supportQaTab: 'Support QA',
      search: 'Search',
      searchPlaceholder: 'SKU, ASIN, or title',
      searchProducts: 'Search products',
      status: 'Status',
      all: 'All',
      active: 'Active',
      inactive: 'Inactive',
      type: 'Type',
      allTypes: 'All types',
      platform: 'Platform',
      title: 'Title',
      updated: 'Updated',
      details: 'Details',
      open: 'Open',
      noProducts: 'No products.',
      showing: 'Showing',
      of: 'of',
      rows: 'Rows',
      previous: 'Previous',
      next: 'Next',
      page: 'Page',
      noPreview: 'No import preview selected.',
      noPreviewHelp: 'Use Upload Product File at the top of the page to preview workbook changes before applying them.',
      importHistory: 'Import History',
      noImports: 'No imports.',
      supportReview: 'Support QA Review',
      supportReviewHelp: 'Review support wording. Product facts stay in structured product tools.',
      qaSearchPlaceholder: 'SKU, family, or answer text',
      searchSuggestions: 'Search QA suggestions',
      productFamily: 'Product / Family',
      intent: 'Intent',
      risk: 'Risk',
      proposedAnswer: 'Proposed Answer',
      evidence: 'Evidence',
      actions: 'Actions',
      noSuggestions: 'No QA suggestions in this view.',
      uploadTitle: 'Upload Product File',
      uploadDescription: 'Upload the Bizsprite Product Info workbook to preview changes. Product_Master is required; optional support sheets may stay blank. Nothing is applied until you review the diff and choose Apply Import.',
      workbook: 'Workbook',
      workbookHelp: 'Accepted format: .xlsx. Use Download Template for a blank Bizsprite workbook or Export Current Data to edit existing products.',
      chooseWorkbook: 'Choose Workbook',
      fieldDictionary: 'Field Dictionary',
      uploadedColumn: 'Uploaded Column',
      productField: 'Product Field',
      usedFor: 'Used For',
      aiFact: 'AI Fact',
      cancel: 'Cancel',
      generateTitle: 'Generate Suggestions',
      generateDescription: 'Generate support QA suggestions from recent customer evidence and the latest changed products. Suggestions stay in review until approved.',
      generateBoundary: 'Product facts remain in Product Info. This creates support wording only.',
      advanced: 'Advanced',
      generate: 'Generate',
      advancedTitle: 'Advanced Product QA Tools',
      advancedBoundary: 'Advanced tools are for controlled review, troubleshooting, and batch management. Suggestions still require approval before apply.',
      generateByScope: 'Generate By Scope',
      selectedSkus: 'Selected SKUs',
      selectedSkusPlaceholder: 'Comma or space separated SKUs',
      chooseFamily: 'Choose family',
      reviewFilters: 'Review Filters',
      reviewFiltersHelp: 'Use filters when auditing a specific job, intent, risk, or family.',
      reviewJob: 'Review Job',
      allJobs: 'All jobs',
      pending: 'Pending',
      approved: 'Approved',
      rejected: 'Rejected',
      action: 'Action',
      allActions: 'All actions',
      create: 'Create',
      update: 'Update',
      deactivate: 'Deactivate',
      keep: 'Keep',
      conflict: 'Conflict',
      category: 'Category',
      allCategories: 'All categories',
      allIntents: 'All intents',
      allRisk: 'All risk',
      high: 'High',
      medium: 'Medium',
      low: 'Low',
      recentEvidence: 'Recent Evidence',
      query: 'Query',
      failure: 'Failure',
      noEvidence: 'No evidence loaded.',
      productFamilies: 'Product Families',
      family: 'Family',
      skus: 'SKUs',
      noFamilies: 'No families loaded.',
      close: 'Close',
      noSourceColumns: 'No source columns available.',
      sourceColumn: 'Source Column',
      uploadedValue: 'Uploaded Value',
      noRawColumns: 'No raw columns',
      noBucketRows: 'No rows in this bucket.',
      sku: 'SKU',
      asin: 'ASIN',
      product: 'Product',
      productType: 'Product Type',
      yes: 'Yes',
      no: 'No',
      diffNew: 'New',
      diffChanged: 'Changed',
      diffWillDeactivate: 'Will Deactivate',
      invalid: 'Invalid',
      invalidLower: 'invalid',
      showingFirst: 'Showing first',
      sourceColumnsLower: 'source columns',
      rowsLower: 'rows',
      evidenceItem: 'evidence item',
      evidenceItems: 'evidence items',
      merged: 'merged',
      requiredProductKey: 'Required product key',
      amazonLookupKey: 'Amazon lookup key',
      productNameUse: 'Product name used for search and support answers',
      brandFactUse: 'Brand fact used in catalog answers',
      catalogGroupingUse: 'Catalog grouping and filters',
      listingClaimsUse: 'Listing claims and support wording',
      searchHintsUse: 'Search hints',
      productSpecsUse: 'Product specs',
      priceReferenceOnly: 'Reference only in v1',
      compatibilityShippingUse: 'Compatibility and shipping support',
      auditFutureMappingUse: 'Kept for audit and future mapping',
      intentCompatibility: 'Compatibility',
      intentDimensions: 'Fit / Dimensions',
      intentPurchase: 'Purchase Guidance',
      intentVariant: 'Variant Selection',
      intentWarranty: 'Warranty',
      intentAfterSales: 'After-sales',
      intentUnknown: 'Unknown / Handoff',
      categoryCompatibility: 'Compatibility Decision',
      categoryDimensions: 'Fit & Dimensions',
      categoryPurchase: 'Purchase Guidance',
      categoryVariant: 'Variant Selection',
      categoryWarranty: 'Warranty Policy',
      categoryAfterSales: 'After-sales Triage',
      categoryUnknown: 'Unknown / Handoff',
      allActiveScanEstimate: 'All Active Scan Estimate',
      activeProductsBatchHelp: 'active products. Use selected SKU batches to generate suggestions.',
      newEvidenceItemCollected: 'new evidence item collected.',
      newEvidenceItemsCollected: 'new evidence items collected.',
      applyImport: 'Apply Import',
      invalidRowsHelp: 'Invalid rows are visible below. Upload a corrected workbook before applying.',
      willDeactivateHelp: 'Rows in Will Deactivate are active SKUs missing from this workbook and will be marked inactive.',
      unchangedSkusHidden: 'unchanged SKUs are hidden from the review tabs.',
      importLabel: 'import',
      warningLabel: 'warning',
      viewDiff: 'View Diff',
      unmappedSourceColumns: 'Unmapped source columns',
      pendingAgentSuggestions: 'Pending QA Agent Suggestions',
      deactivateConfirm: 'existing SKUs will be marked inactive. Apply this import?',
      applyBulkPrefix: 'Apply',
      applyBulkSuffix: 'to the current filtered batch? This affects up to one backend batch at a time.',
      generateSuggestions: 'Generate Suggestions',
      applyApproved: 'Apply Approved',
      selected: 'selected',
      approveSelected: 'Approve Selected',
      rejectSelected: 'Reject Selected',
      approve: 'Approve',
      reject: 'Reject',
      suggestionsLower: 'suggestions',
      collectEvidence: 'Collect Evidence',
      refreshFamilies: 'Refresh Families',
      changedProducts: 'Changed Products',
      failedSearches: 'Failed Searches',
      selectedFamily: 'Selected Family',
      suggestionsUpdated: 'suggestions updated.',
      appliedCount: 'applied',
      approvedRemain: 'approved suggestions remain for the next batch.',
      importStatuses: {
        uploaded: 'Uploaded', previewed: 'Previewed', ready: 'Ready',
        applied: 'Applied', failed: 'Failed', pending: 'Pending',
      },
      jobStatuses: {
        pending: 'Pending', running: 'Running', completed: 'Completed',
        failed: 'Failed', approved: 'Approved', rejected: 'Rejected',
      },
      brand: 'Brand',
      price: 'Price',
      changeReason: 'Change Reason',
      sourceColumns: 'Source Columns',
      reason: 'Reason',
      overview: 'Overview',
      listingFields: 'Listing Fields',
      dimensions: 'Dimensions',
      compatibility: 'Compatibility',
      faq: 'FAQ',
      afterSales: 'After-sales',
      rawSource: 'Raw Source',
      approvedLink: 'Approved Product Link',
      openApprovedLink: 'Open approved link',
      missingApprovedLink: 'No approved product link. Voice and SMS must fail closed instead of creating a URL from ASIN or other product data.',
      parentAsin: 'Parent ASIN',
      salesChannel: 'Sales Channel',
      source: 'Source',
      material: 'Material',
      color: 'Color',
      warranty: 'Warranty',
      itemSize: 'Item Size',
      itemWeight: 'Item Weight',
      packageSize: 'Package Size',
      packageWeight: 'Package Weight',
      qaAgent: 'QA Agent',
      manual: 'Manual',
      description: 'Description',
      bulletPoints: 'Bullet Points',
      keywords: 'Keywords',
      dimensionColumns: 'Dimension Source Columns',
      noCompatibility: 'No product-specific compatibility rules.',
      noFaq: 'No product-specific FAQ.',
      noAfterSales: 'No after-sales rules.',
      productsCovered: 'Products Covered',
      needsAttention: 'Needs Attention',
      selectSuggestionPage: 'Select current QA suggestion page',
      selectSuggestion: 'Select QA suggestion',
      noFamily: 'No family',
      showFilters: 'Show Filters',
      hideFilters: 'Hide Filters',
      loadProductsFailed: 'Failed to Load Products',
      previewReady: 'Import Preview Ready',
      uploadFailed: 'Upload Failed',
      templateDownloaded: 'Product template downloaded',
      downloadFailed: 'Download Failed',
      dataExported: 'Current product data exported',
      exportFailed: 'Export Failed',
      resolveInvalid: 'Resolve Invalid Rows First',
      correctWorkbook: 'Upload a corrected workbook before applying this import.',
      importAppliedReview: 'Import Applied; QA Review Ready',
      importApplied: 'Import Applied',
      applyFailed: 'Apply Failed',
      enterSku: 'Enter at Least One SKU',
      tooManySkus: 'Too Many SKUs',
      maxSkus: 'Run at most 50 SKUs per QA Agent scan.',
      chooseProductFamily: 'Choose a Product Family',
      scanReady: 'QA Agent Scan Ready for Review',
      scanFailed: 'QA Agent Scan Failed',
      suggestionsReady: 'Suggestions Ready for Review',
      generateFailed: 'Generate Suggestions Failed',
      evidenceCollected: 'Evidence Collected',
      evidenceFailed: 'Evidence Collection Failed',
      familiesRefreshed: 'Product Families Refreshed',
      familyRefreshFailed: 'Family Refresh Failed',
      selectSuggestions: 'Select Suggestions First',
      suggestionsApproved: 'Suggestions Approved',
      suggestionsRejected: 'Suggestions Rejected',
      bulkUpdateFailed: 'Bulk Update Failed',
      suggestionApproved: 'Suggestion Approved',
      suggestionRejected: 'Suggestion Rejected',
      suggestionUpdateFailed: 'Suggestion Update Failed',
      noQaJob: 'No QA Job Available',
      approvedApplied: 'Approved FAQ Suggestions Applied',
      approvedApplyFailed: 'Apply Approved Failed',
      loadProductFailed: 'Failed to Load Product',
    },
    extensions: {
      helpTitle: 'Extension Management',
      helpDescription: 'See whether each AI extension is running, and start, stop or restart it.',
      start: 'Start',
      startHelp: 'Starts the AI program for this extension. Once it shows Running, place a test call to confirm it answers.',
      stop: 'Stop',
      stopHelp: 'Stops the AI program for this extension. Confirm there are no active calls before using it.',
      restart: 'Restart',
      restartHelp: 'Stops and starts the AI program. It will not fix account or line configuration problems.',
      refreshStatus: 'Refresh status',
      refreshHelp: 'Updates the status shown on this page only. It does not restart the extension.',
      runtimeWarning: 'Running means the extension\'s AI program has started; it does not guarantee calls connect, so place a test call to confirm. Refresh status only updates this page and does not restart the extension.',
      total: 'Total',
      running: 'Running',
      stopped: 'Stopped',
      transitioning: 'Transitioning',
      parked: 'Registration failed · needs attention',
      error: 'Error',
      unknown: 'Unknown',
      extensions: 'Extensions',
      extensionDomain: 'Extension / Domain',
      concurrentCalls: 'Concurrent calls',
      concurrentCallsHint: 'Change in the OneSuite Business portal',
      status: 'Status',
      runtime: 'Runtime',
      actions: 'Actions',
      alwaysOn: '24x7 when started',
      noExtensions: 'No extensions available.',
      notAvailable: 'N/A',
      startTitle: 'Start the AI program for this extension. Confirm with a test call.',
      stopTitle: 'Stop the AI program for this extension. Check for active calls first.',
      restartTitle: 'Stop and start the AI program for this extension.',
      loadFailed: 'Failed to load extensions',
      statusFailed: 'Failed to fetch statuses',
      pleaseWait: 'Please wait',
      pleaseWaitDetail: 'Please wait a moment before performing another action',
      extension: 'Extension',
      started: 'started',
      stoppedAction: 'stopped',
      restarted: 'restarted',
      startFailed: 'Start failed',
      stopFailed: 'Stop failed',
      restartFailed: 'Restart failed',
    },
    callHistory: {
      helpTitle: 'Call History',
      helpDescription: 'Inspect recent calls handled by each extension and open a full call detail view.',
      pickExtension: 'Pick an extension',
      pickExtensionDetail: 'Choose the agent extension from the dropdown to filter call logs to that number.',
      scanStatus: 'Scan status & reasons',
      scanStatusDetail: 'Badges show completion, failure, or in-progress status; hover the reason column to read the full end reason.',
      openDetails: 'Open details',
      openDetailsDetail: 'Click View Details to open the full transcript and call handling details.',
      pageTitle: 'Call History',
      refresh: 'Refresh',
      recentCalls: 'Recent Calls',
      extension: 'Extension',
      monitoring: 'Monitoring AI Agent Activity',
      status: 'Status',
      caller: 'Caller',
      time: 'Time',
      duration: 'Duration',
      reason: 'Reason',
      actions: 'Actions',
      noRecords: 'No call records found.',
      viewDetails: 'View Details',
      loadError: 'Error loading data',
      callsLoadFailed: 'Failed to load calls',
      completed: 'Completed',
      failed: 'Failed',
      inProgress: 'In progress',
    },
    callDetail: {
      helpTitle: 'Call Detail',
      helpDescription: 'Audit a single call: who dialed in, how long it ran, and review the saved recording.',
      reviewSummary: 'Review summary',
      reviewSummaryDetail: 'Check caller info, start time, duration, status, and end reason before diving deeper.',
      listenRecording: 'Listen to recording',
      listenRecordingDetail: 'Use the audio player as the source of truth for the call.',
      generateTranscript: 'Generate transcript',
      generateTranscriptDetail: 'Use Transcribe only when text is needed; it runs on the full saved recording after the call.',
      back: 'Back to History',
      pageTitle: 'Call Details',
      id: 'ID',
      exportJson: 'Export JSON',
      summary: 'Summary',
      caller: 'Caller',
      startTime: 'Start Time',
      duration: 'Duration',
      status: 'Status',
      endReason: 'End Reason',
      recording: 'Call Recording',
      noRecording: 'No recording is available for this call.',
      loadingRecording: 'Loading recording...',
      transcribe: 'Transcribe',
      transcribing: 'Transcribing',
      download: 'Download',
      transcribingDetail: 'Transcribing the full recording. The transcript will appear below when it is ready.',
      recordingMetadataOnly: 'Recording metadata is present, but no playable recording URL was returned.',
      transcript: 'Conversation Transcript',
      hide: 'Hide',
      show: 'Show',
      toolMessages: 'tool messages',
      noSavedTranscript: 'No saved transcript is available. Use Transcribe above to generate one from the recording.',
      recordingStatusFirst: 'No transcript is available. Recording metadata exists; review the recording status above before attempting transcription.',
      noTranscript: 'No transcript is available for this call.',
      tenantRequired: 'Tenant context required',
      tenantRequiredDetail: 'Please log in or select a tenant.',
      callNotFound: 'Call not found',
      detailsLoadError: 'Error loading details',
      recordingLoadFailed: 'Failed to load recording',
      transcriptLoaded: 'Transcript loaded',
      transcriptGenerated: 'Transcript generated',
      transcriptionFailed: 'Transcription failed',
      transcriptionUnavailable: 'Unable to transcribe recording.',
      completed: 'Completed',
      failed: 'Failed',
    },
    sms: {
      helpTitle: 'SMS',
      helpDescription: 'Review transactional outbound SMS activity recorded for your account.',
      reviewActivity: 'Review activity',
      reviewActivityDetail: 'See recorded destinations, message types, timestamps, and provider status.',
      filterSearch: 'Filter and search',
      filterSearchDetail: 'Filter by recorded status or message type, or search the loaded activity.',
      interpretStatus: 'Interpret status carefully',
      interpretStatusDetail: 'Submitted means the provider accepted the request; only Delivered confirms a delivery receipt.',
      pageTitle: 'SMS',
      pageSummary: 'Real outbound SMS activity recorded for this account',
      recorded: 'Recorded',
      inProgress: 'In progress',
      delivered: 'Delivered',
      failed: 'Failed',
      searchPlaceholder: 'Search phone, content, reference...',
      allStatuses: 'All statuses',
      providerAccepted: 'Provider accepted',
      submittedLegacy: 'Submitted (legacy)',
      submitted: 'Submitted',
      undeliverable: 'Undeliverable',
      expired: 'Expired',
      pending: 'Pending',
      queued: 'Queued',
      allTypes: 'All types',
      infoLink: 'Info Link',
      notification: 'Notification',
      verification: 'Verification',
      callback: 'Callback',
      booking: 'Booking',
      general: 'General',
      productLink: 'Product link',
      ticketForm: 'Support form',
      ticketUpdate: 'Ticket update',
      help: 'Help',
      created: 'Created',
      processing: 'Sending',
      suppressed: 'Blocked',
      resultUnconfirmed: 'Result not confirmed',
      destination: 'Destination',
      message: 'Message',
      type: 'Type',
      status: 'Status',
      activityTime: 'Activity time',
      loading: 'Loading SMS activity...',
      noActivity: 'No SMS activity found.',
      unknown: 'Unknown',
      errorInfo: 'Error info',
      records: 'record(s)',
      page: 'Page',
      of: 'of',
      previous: 'Previous',
      next: 'Next',
      loadFailed: 'Unable to load SMS activity',
      loadFailedDetail: 'Please try again. If the problem continues, contact support.',
      inboxTitle: 'Customer texts',
      inboxSummary: 'Texts sent to your SMS number that are not a reply to a ticket or callback. Follow up from your own records.',
      inboxFromHistory: 'Recent contact',
      inboxFromHistoryDetail: 'This number recently called you, texted with you, or asked for a callback.',
      inboxAssigned: 'Forwarded by support',
      inboxAssignedDetail: 'Aiker support forwarded this text to your account.',
      inboxFrom: 'From',
      inboxReceived: 'Received',
      inboxMarkHandled: 'Mark handled',
      inboxReopen: 'Reopen',
      inboxShowHandled: 'Show handled',
      inboxHandled: 'Handled',
      inboxLoadFailed: 'Unable to load customer texts',
      inboxUpdateFailed: 'Unable to update this text',
    },
    contacts: {
      pageTitle: 'Contacts',
      pageSummary: 'Directory records, routing aliases, and transfer targets',
      addContact: 'Add Contact',
      csvMaintenance: 'CSV Maintenance',
      search: 'Search',
      searchPlaceholder: 'Name, alias, extension, phone…',
      status: 'Status',
      allStatuses: 'All statuses',
      active: 'Active',
      inactive: 'Inactive',
      onLeave: 'On leave',
      prospect: 'Prospect',
      contacts: 'contacts',
      noMatches: 'No contacts match the current filters.',
      page: 'Page',
      of: 'of',
      previous: 'Previous',
      next: 'Next',
      employee: 'Employee',
      department: 'Department',
      queue: 'Queue',
      client: 'Client',
      visitor: 'Visitor',
      editContact: 'Edit Contact',
      new: 'New',
      formSummary: 'Directory record and routing behavior',
      routingIdentity: 'Routing Identity',
      name: 'Name',
      fullNamePlaceholder: 'Full name…',
      otherNames: 'Other names',
      aliasesPlaceholder: 'Aliases callers may say, separated by commas or new lines…',
      extensionNumber: 'Extension number',
      contactType: 'Contact Type',
      contactDetails: 'Contact Details',
      phoneNumber: 'Phone number',
      email: 'Email',
      notes: 'Notes',
      notesPlaceholder: 'Internal notes…',
      runtimeBehavior: 'Runtime Behavior',
      supportsConsultation: 'Supports consultation transfer',
      voicemailEnabled: 'Voicemail enabled',
      voicemailManagedExternally: 'Voicemail is managed by your phone provider / PBX. Contact your phone administrator for the mailbox and listening instructions.',
      operatorAnyTransfer: 'Operator — can receive any transfer',
      cancel: 'Cancel',
      saveContact: 'Save Contact',
      positionTitle: 'Position / Title',
      companyName: 'Company Name',
      industry: 'Industry',
      tier: 'Tier',
      standard: 'Standard',
      vip: 'VIP',
      partner: 'Partner',
      serviceType: 'Service Type',
      contractExpiry: 'Contract Expiry',
      activeTransferTarget: 'Active — appears as transfer target',
      inactiveHidden: 'Inactive — hidden from routing',
      activeTransfers: 'Active — available for transfers',
      leaveUnavailable: 'On leave — temporarily unavailable',
      inactiveNotOffered: 'Inactive — not offered as target',
      nameRequired: 'Name is required',
      extensionRequired: 'Extension number is required for transfer targets',
      phoneOrExtensionRequired: 'Enter a phone number or extension',
      departmentPlaceholder: 'e.g. Engineering',
      positionPlaceholder: 'e.g. Senior Developer',
      companyPlaceholder: 'e.g. Acme Corp',
      industryPlaceholder: 'e.g. Technology',
      supplierPlaceholder: 'Supplier Company Name',
      servicePlaceholder: 'e.g. Office Supplies, IT Services',
      emailPlaceholder: 'name@example.com',
      noAliases: 'No aliases',
      extension: 'Extension',
      phone: 'Phone',
      transfer: 'Transfer',
      consultationTransfer: 'Consultation transfer',
      blindTransferOnly: 'Blind transfer only',
      consultation: 'Consultation',
      blindOnly: 'Blind only',
      flags: 'Flags',
      voicemail: 'Voicemail',
      operator: 'Operator',
      edit: 'Edit Contact',
      delete: 'Delete Contact',
      loadFailed: 'Failed to load contacts',
      deleted: 'Contact deleted',
      deleteFailed: 'Delete failed',
      updated: 'Contact updated',
      created: 'Contact created',
      saveFailed: 'Save failed',
      csvDescription: 'Download the standard contacts template, fill or edit the rows, then upload the completed file. Matching contacts are updated; new rows are created.',
      acceptedFormats: 'Accepted formats',
      acceptedFormatsDetail: 'CSV, XLSX, or XLS. Required column: name. Extension, department, transfer settings, and notes are optional.',
      downloadTemplate: 'Download Template',
      downloadCurrent: 'Download Current Contacts',
      uploadFile: 'Upload File',
      close: 'Close',
      deleteTitle: 'Delete Contact',
      deleteConfirmPrefix: 'Are you sure you want to delete',
      deleteConfirmSuffix: 'This action cannot be undone.',
      deleteAction: 'Delete',
      unknown: 'Unknown',
      validationIssues: 'Validation issues',
      importSkipped: 'Import skipped',
      importSkippedDetail: 'No valid rows to import. Fix errors and try again.',
      importFinished: 'Import finished',
      uploadFailed: 'Upload failed',
      noRows: 'No rows found in file',
      rowsHaveErrors: 'row(s) have errors.',
      validRowsImported: 'valid row(s) will be imported.',
      imported: 'Imported',
      failedCount: 'failed',
      skippedRows: 'row(s) skipped (see error report).',
      invalidContactType: 'Invalid contact_type; expected one of:',
      invalidExtension: 'Extension must be alphanumeric or hyphens',
      duplicateExtension: 'Duplicate extension in file',
      invalidPhone: 'Phone contains invalid characters',
    },
    supportTickets: {
      pageTitle: 'Support Tickets',
      pageSummary: 'Track callbacks, product questions, returns, replacements, and human follow-ups',
      createTicket: 'Create a ticket',
      createTicketHelp: 'Log customer name, phone, type, summary, priority, and optional product or order context.',
      filterSearch: 'Filter and search',
      filterSearchHelp: 'Use status, type, priority, and search to find callback and support follow-up work.',
      closeLoop: 'Close the loop',
      closeLoopHelp: 'Mark tickets contacted or completed after follow-up. Use cancelled when the request is no longer needed.',
      refresh: 'Refresh',
      newTicket: 'New Ticket',
      searchPlaceholder: 'Search customer, QA ID, category, issue, product, order, or AI summary...',
      allStatus: 'All Status',
      allTypes: 'All Types',
      allPriority: 'All Priority',
      pending: 'Pending',
      contacted: 'Contacted',
      completed: 'Completed',
      cancelled: 'Cancelled',
      urgent: 'Urgent',
      high: 'High',
      normal: 'Normal',
      low: 'Low',
      callback: 'Callback',
      emailBack: 'Email Back',
      ecommerceSupport: 'Ecommerce Support',
      compatibilityReview: 'Compatibility Review',
      returnRefund: 'Return / Refund',
      replacement: 'Replacement',
      missingItem: 'Missing Item',
      damagedItem: 'Damaged Item',
      bulkPurchase: 'Bulk Purchase',
      invoiceRequest: 'Invoice Request',
      humanEscalation: 'Human Escalation',
      other: 'Other',
      departmentNotConfigured: 'Department not configured',
      transferFailed: 'Transfer failed',
      noTransferTarget: 'No transfer target',
      callbackRequested: 'Callback requested',
      productQuestion: 'Product question',
      returnOrRefund: 'Return or refund',
      missingItemIssue: 'Missing item',
      damagedItemIssue: 'Damaged item',
      departmentRoutingMissing: 'Department routing is not configured',
      transferTargetNotFound: 'Transfer target was not found',
      transferUnavailable: 'Transfer target was unavailable',
      noDepartmentMatch: 'No matching department was found',
      noContactMatch: 'No matching contact was found',
      markContacted: 'Mark contacted',
      markCompleted: 'Mark completed',
      clear: 'Clear',
      selectAll: 'Select all',
      selectTicket: 'Select ticket for',
      type: 'Type',
      customer: 'Customer',
      issueSummary: 'Issue / Summary',
      priority: 'Priority',
      status: 'Status',
      created: 'Created',
      actions: 'Actions',
      loading: 'Loading...',
      noTickets: 'No support tickets yet (newest first).',
      unknownCustomer: 'Unknown customer',
      followUpRequested: 'Support follow-up requested',
      target: 'Target',
      needsSetup: 'Needs setup',
      markDone: 'Mark done',
      options: 'Options',
      viewDetails: 'View details',
      call: 'Call',
      cancel: 'Cancel',
      page: 'Page',
      upTo: 'up to',
      perPageNewest: 'per page, newest first',
      perPageOldest: 'per page, oldest first',
      previous: 'Previous',
      next: 'Next',
      newTicketTitle: 'New Support Ticket',
      customerName: 'Customer Name',
      customerNamePlaceholder: 'John Doe',
      phoneNumber: 'Phone Number',
      customerEmail: 'Customer Email',
      platform: 'Platform',
      platformPlaceholder: 'Amazon / Website / Phone',
      orderNumber: 'Order Number',
      product: 'Product',
      issueType: 'Issue Type',
      requestedAction: 'Requested Action',
      create: 'Create',
      optional: 'Optional',
      productPlaceholder: 'Product name or SKU',
      issueTypePlaceholder: 'Fit, return, missing item...',
      actionPlaceholder: 'Review compatibility, call back, replacement...',
      summaryPlaceholder: 'Customer question, issue, and relevant context',
      error: 'Error',
      success: 'Success',
      nameNumberRequired: 'Name and number are required',
      emailRequired: 'Customer email is required for Email Back tickets',
      ticketCreated: 'Support ticket created',
      createFailed: 'Failed to create support ticket',
      loadFailed: 'Failed to load support tickets',
      updated: 'Updated',
      requestMarked: 'Request marked as',
      updateFailed: 'Failed to update status',
      bulkUpdate: 'Bulk update',
      updatedCount: 'updated',
      failedCount: 'failed',
      none: 'None',
      ticketDetails: 'Ticket Details',
      unknown: 'Unknown',
      noPhone: 'No phone',
      email: 'Email',
      notAvailable: 'N/A',
      noSummary: 'No summary',
      context: 'Context',
      order: 'Order',
      device: 'Device',
      handling: 'Handling',
      category: 'Category',
      urgency: 'Urgency',
      requiredFields: 'Required Fields',
      collectedFields: 'Collected Fields',
      aiSummary: 'AI Summary',
      close: 'Close',
    },
  },
  zh: {
    shared: {
      featureUnavailable: '此功能尚未启用',
      featureUnavailableDetail: '如需添加此功能，请联系 Bizsprite 合作伙伴或直接联系我们。',
      loadingPanel: '正在加载客户控制台',
      checkingAccess: '正在检查租户访问权限……',
    },
    settings: {
      pageTitle: '公司信息与 AI 设置',
      pageDescription: '配置公司资料和 AI 助手设置',
      profileStep: '公司资料',
      profileStepDescription: '维护来电客户和 AI 需要依赖的基础信息。',
      voiceStep: '欢迎语与声音',
      voiceStepDescription: '设置 AI 如何开始对话以及使用的声音。',
      contextStep: '业务背景与时区',
      contextStepDescription: '补充业务背景和时间处理方式。',
      importCsv: '导入 CSV',
      downloadTemplate: '下载模板',
      companyName: '公司名称',
      companyPhone: '公司电话',
      companyAddress: '公司地址',
      welcomeMessage: '欢迎语',
      welcomeHelp: '客户接通后首先听到的内容。建议保持友好和简洁。',
      welcomePlaceholder: '例如：您好，感谢致电。请问有什么可以帮助您？',
      welcomeMissing: '尚未配置——保存欢迎语之前，AI 将使用通用欢迎语。',
      aiVoice: 'AI 声音',
      voiceHelp: '选择 AI 助手的声音。保存前可使用“测试声音”试听。',
      voicePlaceholder: '尚未配置——请选择声音',
      testVoice: '测试声音',
      companyContext: 'AI 使用的公司背景',
      companyContextHelp: '提供公司行业、服务范围、常见客户问题等背景，帮助 AI 更准确地理解业务并回应来电。',
      companyContextExamples: '示例：“我们是一家提供家庭牙科和美容牙科服务的诊所”，或“我们提供云迁移、网络安全和托管服务”。',
      companyContextPlaceholder: '描述公司、服务和常见来电需求……',
      timezone: '时区',
      timezoneHelp: '用于基于时间的欢迎语和通话记录显示。预约时区规则请在“日程安排”中配置。',
      timezonePlaceholder: '尚未配置——请选择时区',
      applyTimezone: '应用',
      back: '返回',
      moreSettings: '下方还有更多设置',
      step: '步骤',
      of: '/',
      continue: '继续',
      saveContinue: '保存并继续',
      saveFinish: '保存并完成',
      settingsSaved: '设置已保存',
      settingsSavedDetail: 'AI 业务背景和显示时区已更新。',
      timezoneSetFromAddress: '已根据地址设置时区',
      appliedTimezone: '已应用',
      noTenantId: '缺少租户 ID',
      noTenant: '缺少租户信息',
      companyInfoSaved: '公司信息已保存',
      companyInfoSaveFailed: '保存公司信息失败',
      importFailed: '导入失败',
      noCsvRows: 'CSV 中没有数据行',
      companyInfoImported: '公司信息已导入',
      saveImportedCompanyInfo: '请使用“保存并继续”保存此步骤。',
      aiSettingsSaved: 'AI 设置已保存',
      aiSettingsSaveFailed: '保存 AI 设置失败',
      voiceSettingsUpdated: '语音设置已更新',
      saveVoiceSettingsHelp: '请使用当前步骤的保存按钮应用更改。',
      goToStep: '转到',
    },
    scheduling: {
      pageTitle: '日程安排',
      pageSummary: '管理预约页面、可预约时间、事件和预约记录。',
      filtering: '当前筛选',
      selectedAccount: '已选账号',
      calendarDisplay: '日历显示时区',
      displayTooltip: '仅改变当前工作区中时间的显示方式，不会改变预约可用时间或资源时区。',
      helpDescription: '在一个工作区中连接日历、定义预约类型、设置可预约时间并查看预约记录。',
      connectCalendars: '连接日历',
      connectCalendarsDetail: '从侧边栏连接 Google、Apple、Calendly 或 Teams。',
      createAppointmentTypes: '创建预约类型',
      createAppointmentTypesDetail: '定义客户可以预约的内容以及预约写入的位置。',
      setAvailability: '设置可预约时间',
      setAvailabilityDetail: '配置每周时间、缓冲时间、每日上限和特殊日期。',
      reviewRecords: '查看记录',
      reviewRecordsDetail: '查看已确认预约、同步失败和时间冲突提醒。',
      connectedCalendars: '已连接日历',
      bookingTimezoneTitle: '预约时区规则',
      bookingTimezoneHelp: '每个预约资源把地点、日历账号、预约页面和时区关联在一起。单时区模式统一使用一个预约时区；多时区模式使用各资源配置的地点和时区。',
      mode: '模式',
      singleTimezone: '单一预约时区',
      multipleTimezones: '多个资源时区',
      bookingTimezone: '预约时区',
      fallbackTimezone: '备用时区',
      saveBookingTimezone: '保存预约时区',
      noTenant: '缺少租户 ID',
      saved: '预约时区设置已保存',
      saveFailed: '保存预约时区设置失败',
      openConnections: '打开日历连接',
      bookingPageTab: '预约页面',
      availabilityTab: '可预约时间',
      eventsTab: '日历事件',
      recordsTab: '预约记录',
      overviewTab: '概览',
      all: '全部',
      minutes: '分钟',
      save: '保存',
      cancel: '取消',
      edit: '编辑',
      delete: '删除',
      editService: '编辑服务',
      deleteService: '删除服务',
      serviceName: '服务名称',
      add: '添加',
      serviceTypes: '服务类型',
      serviceTypesHelp: '定义客户可以选择的服务名称和时长。',
      addService: '添加服务',
      noServiceTypes: '尚未添加服务类型',
      noServiceTypesHelp: '请至少添加一个服务，客户才能通过此页面预约。',
      serviceTypeCount: '个服务类型',
      serviceTypeCountSingle: '个服务类型',
      maxPerDay: '每天最多',
      perDay: '次',
      configureSchedule: '配置预约时间',
      settings: '设置',
      deleteBookingPage: '删除预约页面',
      schedule: '预约时间',
      noSchedule: '尚未配置周期性预约时间',
      targetCalendar: '目标日历',
      noTargetCalendar: '尚未选择目标日历',
      location: '地点',
      deleteBookingTitle: '删除预约页面？',
      deleteBookingBody: '此操作会从工作区删除预约页面及其服务类型。',
      bookingPages: '预约页面',
      bookingPagesQuestion: '客户可以预约什么，预约会写入哪个日历？',
      newBookingPage: '新建预约页面',
      noBookingPages: '尚未创建预约页面',
      noBookingPagesHelp: '创建第一个预约页面后即可开始接受预约。',
      createBookingPage: '创建预约页面',
      updateServiceFailed: '更新服务失败',
      createServiceFailed: '创建服务失败',
      deleteServiceFailed: '删除服务失败',
      deleteFailed: '删除失败',
      bookingPageUpdated: '预约页面已更新',
      bookingPageCreated: '预约页面已创建',
      saveFailedGeneric: '保存失败',
      bookingPageDeleted: '预约页面已删除',
      deleteServiceConfirm: '删除这个服务选项？',
      setupRequired: '需要先完成设置',
      noCalendars: '尚未连接日历',
      noCalendarsHelp: '请先连接至少一个日历账号，再创建预约类型、同步事件和查看预约记录。',
      connectCalendar: '连接日历',
      scheduleUpdated: '预约时间已更新',
      availabilityNoPagesHelp: '请先创建预约页面，再在这里管理可预约时间。',
      availabilitySummary: '管理每周时间、特殊日期、缓冲时间和预约限制。',
      calendar: '日历',
      exception: '个特殊日期',
      exceptions: '个特殊日期',
      weeklyHours: '每周可预约时间',
      noWeeklySchedule: '尚未设置周期性的每周时间。',
      rules: '规则',
      buffer: '缓冲时间',
      unlimitedDaily: '每日预约不限量',
      editHours: '编辑时间',
      allCalendars: '全部日历',
      selectedAccountOption: '当前所选账号',
      eventsSummary: '查看已同步事件，并在需要时添加人工日历事件。',
      allDay: '全天',
      previousMonth: '上个月',
      nextMonth: '下个月',
      newAppointment: '新建事件',
      weekdaysShort: ['日', '一', '二', '三', '四', '五', '六'],
      more: '条更多',
      editEvent: '编辑事件',
      deleteEvent: '删除事件',
      noEvents: '本月没有事件。',
      deleteAppointmentFailed: '删除事件失败',
      eventUpdated: '事件已更新',
      appointmentCreated: '事件已创建',
      updateEventFailed: '更新事件失败',
      createAppointmentFailed: '创建事件失败',
      overviewSummary: '查看连接健康、预约健康以及需要处理的事项。',
      connectedCalendarsMetric: '已连接日历',
      activeCount: '个启用',
      visibleCurrentFilter: '当前筛选范围内可见',
      lastSync: '最近同步',
      never: '从未同步',
      syncingNow: '正在同步',
      syncStaleHelp: '事件看起来过期时可执行同步',
      connectionHealth: '连接健康',
      calendarConnections: '日历连接',
      connectionHealthHelp: '健康连接可以保证可预约时间和同步事件可信。',
      activeAccountsView: '个启用账号正在支持当前视图。',
      activeAccountView: '个启用账号正在支持当前视图。',
      noCalendarsYet: '尚未连接任何日历。',
      syncNow: '立即同步',
      bookingHealth: '预约健康',
      currentBookingStatus: '当前预约状态',
      bookingHealthHelp: '以下数量用于判断预约流程是否正常。',
      confirmed: '已确认',
      pending: '待处理',
      syncFailed: '同步失败',
      attention: '需要注意',
      whatNeedsReview: '需要审核的事项',
      attentionHelp: '通过这里判断是否需要进入预约记录进一步处理。',
      noUrgentIssues: '目前没有需要紧急处理的问题。',
      unresolvedConflicts: '条未解决冲突',
      failedSyncRecords: '条记录同步失败',
      pendingBookingRecords: '条待处理预约记录',
      recordsSummary: '优先处理异常，然后查看完整预约历史。',
      attentionNeeded: '需要处理',
      affectedBookings: '条受影响预约',
      syncFailures: '条同步失败',
      conflictRecords: '条冲突记录',
      searchRecords: '按客户、服务或预约 ID 搜索……',
      allRecords: '全部记录',
      noBookingRecords: '尚无预约记录',
      noBookingMatches: '没有符合当前筛选的预约',
      bookingRecordsHelp: '客户开始预约后，已确认、待处理、失败和冲突记录会显示在这里。',
      filterNoMatchHelp: '请尝试其他筛选条件或清除搜索。',
      clearFilters: '清除筛选',
      advancedRetry: '高级：按 ID 手动重试',
      pasteBookingId: '粘贴预约 ID',
      retrySync: '重试同步',
      syncRetried: '已重试同步',
      retryFailed: '重试失败',
      bookingCancelled: '预约已取消',
      cancelFailed: '取消预约失败',
      cancelled: '已取消',
      copied: '已复制',
      conflict: '冲突',
      synced: '已同步',
      conflictAttached: '关联了冲突记录',
      syncStatus: '同步状态',
      bookingLabel: '预约',
      externalEvent: '外部事件',
      bookingPageLabel: '预约页面',
      serviceTypeLabel: '服务类型',
      bookingReference: '预约编号',
      failureReason: '失败原因',
      bookingId: '预约 ID',
      requestId: '请求 ID',
      unresolved: '未解决',
      bookingStatuses: {
        confirmed: '已确认',
        tentative: '暂定',
        pending: '待处理',
        hold: '暂时保留',
        conflict: '存在冲突',
        expired: '已过期',
        cancelled: '已取消',
        unknown: '未知',
      },
      syncStatuses: {
        synced: '已同步',
        pending: '待同步',
        failed: '同步失败',
      },
      conflictResolutions: {
        unresolved: '未解决',
        auto_resolved: '已自动解决',
        manual: '已人工解决',
        ignored: '已忽略',
      },
      cancelBookingTitle: '取消预约？',
      cancelBookingBody: '此预约将标记为已取消，并从当前预约安排中移除。',
      keepBooking: '保留预约',
      cancelBooking: '取消预约',
      copyBookingId: '复制预约 ID',
      copyRequestId: '复制请求 ID',
      details: '详情',
      less: '收起',
      conflictsNeedAttention: '条未解决冲突需要处理',
      customerUnavailable: '无法获取客户信息',
      syncing: '正在同步……',
      syncAll: '全部同步',
      syncAllAccounts: '同步所有账号',
      allAccounts: '全部账号',
      noAccounts: '尚未连接账号。',
      hideConnectionSetup: '收起连接设置',
      connectAccount: '连接账号',
      providerLimit: '已达到此日历服务商当前允许的账号上限。',
      editLabel: '编辑名称',
      recheckCapability: '重新检查能力',
      recheck: '重新检查',
      disconnect: '断开连接',
      disconnectCalendarTitle: '断开日历连接？',
      disconnectCalendarPrefix: '确定断开',
      disconnectCalendarSuffix: '现有记录仍会保留，但不会再同步新数据。',
      editPrefix: '编辑',
      bookingPageDetails: '预约页面详情',
      bookingPageDetailsHelp: '编辑客户可以看到的预约页面信息。可预约时间请在“可预约时间”标签页中单独管理。',
      titleField: '标题',
      bookingTitlePlaceholder: '例如：业务咨询',
      bookingDestination: '预约写入日历',
      selectCalendar: '选择日历……',
      primary: '主要账号',
      timezoneField: '时区',
      locationPlaceholder: '例如：东京办公室',
      allowGuests: '允许受邀者邀请其他人',
      allowGuestsHelp: '仅在允许额外参与者加入预约时开启。',
      saveBookingPage: '保存预约页面',
      editEventTitle: '编辑事件',
      localCalendar: '本地日历',
      disconnected: '已断开连接',
      titleRequired: '必须填写标题',
      startRequired: '必须填写开始时间',
      endRequired: '必须填写结束时间',
      endAfterStart: '结束时间必须晚于开始时间',
      appointmentTitlePlaceholder: '输入事件标题',
      descriptionField: '说明',
      optionalDescription: '可选说明',
      startField: '开始时间',
      endField: '结束时间',
      calendarAccount: '日历账号',
      updateEvent: '更新事件',
      createAppointment: '创建事件',
      availabilitySuffix: '的可预约时间',
      availabilityRules: '可预约规则',
      availabilityRulesHelp: '编辑此预约页面的周期性时间、缓冲时间、每日上限和特殊日期。',
      weeklySchedule: '每周时间',
      weekdaysLong: { mon: '星期一', tue: '星期二', wed: '星期三', thu: '星期四', fri: '星期五', sat: '星期六', sun: '星期日' },
      unavailable: '不可预约',
      removeSlot: '删除时间段',
      addSlot: '添加时间段',
      copyToAll: '复制到所有日期',
      schedulingPolicy: '预约规则',
      bufferBefore: '预约前缓冲（分钟）',
      bufferAfter: '预约后缓冲（分钟）',
      dailyMaxBookings: '每日预约上限',
      zeroUnlimited: '0 = 不限量',
      zeroMeansUnlimited: '0 表示不限量',
      exceptionsHelp: '添加节假日、暂停营业或单次可预约时间。',
      addException: '添加特殊日期',
      noExceptions: '尚未配置特殊日期。',
      closedAllDay: '全天关闭？',
      removeException: '删除特殊日期',
      addTimeSlot: '添加时间段',
      saveAvailability: '保存可预约时间',
      connectAppleTitle: '连接 Apple 日历',
      connectAppleHelp: '使用 Apple ID 和在 appleid.apple.com 创建的 App 专用密码。账号必须开启双重认证。',
      appleId: 'Apple ID',
      appleIdRequired: '必须填写 Apple ID',
      appPassword: 'App 专用密码',
      appPasswordRequired: '必须填写 App 专用密码',
      connect: '连接',
      activeDays: '个启用日期',
    },
    qa: {
      pageTitle: 'QA 知识库',
      pageDescription: '维护面向客户的标准回答、回答边界和转交客服规则。',
      helpFind: '查找客户问题',
      helpFindDetail: '可按问题、答案、分类、平台、必需信息、工单字段或风险说明搜索。',
      helpPolicy: '设置 AI 可以做什么',
      helpPolicyDetail: '直接回答表示立即作答；先收集信息表示补齐资料后再判断；不直接回答表示转交客服。',
      helpHandoff: '让转交更顺畅',
      helpHandoffDetail: '需要人工支持时，请启用工单并列出客服必须收到的信息。',
      policySummary: '规则概览',
      total: '总计',
      active: '启用',
      review: '待审核',
      tickets: '需要工单',
      needsAttention: '需要处理',
      currentList: '当前列表',
      visible: '条可见',
      loaded: '条已加载',
      search: '搜索 QA……',
      allStatuses: '全部状态',
      draft: '草稿',
      needReview: '需要审核',
      disabled: '停用',
      allModes: '全部回答模式',
      direct: '直接回答',
      conditional: '有条件回答',
      noDirect: '不直接回答',
      allCategories: '全部分类',
      allPlatforms: '全部平台',
      clearFilters: '清除筛选',
      createTooltip: '创建新的 QA',
      exportTooltip: '将当前 QA 下载为结构化 XLSX 工作簿',
      importTooltip: '上传编辑后的 CSV、结构化 FAQ DOCX 或结构化 QA XLSX',
      new: '新建',
      export: '导出',
      import: '导入',
      loading: '正在加载 QA',
      refreshing: '正在刷新 QA',
      ticket: '工单',
      needInfo: '缺少信息',
      needFields: '缺少字段',
      needPath: '缺少转交路径',
      needs: '需要',
      noMatches: '没有匹配的 QA。',
      noRows: '暂无 QA。',
      backToList: '返回 QA 列表',
      editorTitle: 'QA 编辑器',
      editorDescription: '编辑 AI 可以说什么、何时需要补充信息，以及何时应由客服跟进。',
      customerQuestion: '客户问题',
      customerQuestionHelp: '填写客户实际会使用的问题表达或触发场景。',
      questionNewPlaceholder: '例如：这个保护套适合我的设备吗？',
      questionPlaceholder: '请选择或新建一个 QA',
      category: '分类',
      categoryHelp: '将相关问题归类，便于客服快速浏览和筛选。',
      categoryPlaceholder: '产品兼容性',
      standardAnswer: '标准答案',
      standardAnswerHelp: 'AI 可以改写或翻译已批准答案，但不能编造该内容之外的事实。',
      answerNewPlaceholder: '填写允许 AI 使用的已批准答案。',
      answerPlaceholder: '答案将在这里显示',
      answerMode: '回答模式',
      answerModeHelp: '直接回答会立即作答；先收集信息会先询问必需资料；不直接回答会转交客服。',
      directAnswer: '直接回答',
      collectFirst: '先收集信息',
      status: '状态',
      statusHelp: '实时 AI 只使用启用状态的条目；尚未准备好时请选择需要审核或草稿。',
      createTicket: '创建客服工单',
      createTicketHelp: '此场景需要客服收到工单时启用。',
      requiredInfo: '必需信息',
      requiredInfoHelp: '列出 AI 在处理有条件回答前必须收集的信息。',
      requiredInfoPlaceholder: '设备品牌；完整型号；订单号……',
      riskNotes: '风险说明',
      riskNotesHelp: '填写 AI 的明确限制，例如退款、换货、官方授权和百分之百适配承诺。',
      riskNotesPlaceholder: '不得承诺退款、赔偿或百分之百适配。',
      escalationTrigger: '转交条件',
      escalationHelp: '说明 AI 应停止尝试回答并转交客服的情况。',
      escalationPlaceholder: '型号不清楚、客户要求退款……',
      ticketFields: '工单字段',
      ticketFieldsHelp: '列出客服在生成的工单中需要收到的信息。',
      ticketFieldsPlaceholder: '订单号；产品；问题；电话……',
      showAdvanced: '显示高级信息',
      hideAdvanced: '隐藏高级信息',
      readinessWarning: '启用前检查提醒',
      dangerZone: '危险操作',
      deleteQa: '删除 QA',
      save: '保存',
      cancel: '取消',
      maintenanceTitle: '模板维护',
      maintenanceDescription: '下载当前结构化 XLSX 工作簿，编辑后重新上传。系统通过 QA ID 或匹配问题更新现有条目，并保留回答模式、必需信息、转交规则、工单字段、风险说明、状态、平台和模板字典。',
      maintenanceContract: 'CSV 字段为 qa_id、question、answer、source、language。结构化 XLSX 会保留工作簿字典；草稿、需要审核和停用条目不会用于实时回答。',
      lastImport: '最近一次导入结果',
      exportXlsx: '导出 XLSX',
      exportCsv: '导出 CSV',
      importFile: '导入文件',
      close: '关闭',
      deleteTitle: '确认删除',
      deleteBody: '确定要删除吗？此操作无法撤销。',
      delete: '删除',
      workbookGuide: '工作簿指南',
      structuredTemplate: '结构化 QA 模板',
      workbookGuardrail: '将工作簿作为规则边界：明确 AI 可以回答什么、必须收集什么，以及何时创建工单。',
      loadedState: '已加载',
      expectedState: '预期模板',
      keyRule: '关键规则',
      rule: '规则',
      commonTicketFields: '常用工单字段',
      rowChecks: '条目检查',
      rowChecksHelp: '这里只显示尚未填写的工作簿字段。',
      ready: '已就绪',
      qaId: 'QA ID',
      qaIdHelp: '模板行 ID，用于工作簿同步，日常编辑通常无需修改。',
      qaIdPlaceholder: 'CP-005 / CUSTOM-001',
      owner: '负责人',
      ownerHelp: '内部跟进或审核负责人。',
      ownerPlaceholder: '客服 / 运营',
      keywords: '关键词 / 意图',
      keywordsHelp: '用于搜索和匹配的可选意图词。',
      keywordsPlaceholder: '适配、兼容、设备型号……',
      platform: '适用平台',
      platformHelp: '此 QA 适用的渠道，例如电商平台、网站或电话。',
      platformPlaceholder: '电商平台 / 官网 / 电话',
      source: '来源',
      sourceHelp: '此 QA 的来源。',
      sourcePlaceholder: '结构化 QA 模板、人工录入……',
      language: '语言',
      languageHelp: '用于兼容旧数据的语言标签。',
      languagePlaceholder: 'en、zh、es……',
      templateGaps: '模板缺失项',
      conditionalMissingRequiredInfo: '有条件回答缺少必需信息。',
      escalationMissingTicketFields: '客服工单转交缺少工单字段。',
      noDirectMissingEscalation: '不直接回答的条目缺少转交路径。',
      templateFieldLabels: {
        template_qa_id: 'QA ID', category: '分类', question: '客户问题',
        answer: '标准答案', keywords: '关键词', required_info: '必需信息',
        answer_mode: '回答模式', should_escalate: '客服工单',
        escalation_trigger: '转交条件', ticket_fields: '工单字段',
        risk_notes: '风险说明', platform: '适用平台', status: '状态',
        owner: '负责人', source: '来源',
      },
      importApplied: '已应用',
      createdRows: '条新增',
      updatedRows: '条更新',
      skippedRows: '条跳过',
      draftRows: '条草稿',
      indexedRows: '条已建立索引',
      importedQas: '已导入 QA：',
      policyWarnings: '条规则警告',
      missingRequiredInfoCount: '条缺少必需信息',
      missingTicketFieldsCount: '条缺少工单字段',
      noDirectNoEscalationCount: '条不直接回答但缺少转交路径',
      reviewImportedRows: '请检查导入条目',
      metadataSaved: '元数据已保存',
      metadataNotSaved: '元数据未保存',
      sheetsLabel: '工作表',
      deletedToast: 'QA 已删除',
      deleteFailedToast: '删除失败',
      questionRequired: '必须填写客户问题',
      answerRequired: '必须填写标准答案',
      createdToast: 'QA 已创建',
      updatedToast: 'QA 已更新',
      apiErrorToast: 'API 错误',
      uploadFailedToast: '上传失败',
      csvDownloadedToast: '当前 QA CSV 已下载',
      downloadFailedToast: '下载失败',
      xlsxDownloadedToast: '结构化 QA XLSX 已下载',
      xlsxFailedToast: '结构化 XLSX 下载失败',
    },
    products: {
      pageTitle: '产品信息',
      pageDescription: '维护最新产品资料，并在需要时审核客服建议。',
      downloadTemplate: '下载模板',
      exportCurrent: '导出当前数据',
      uploadFile: '上传产品文件',
      totalSkus: 'SKU 总数',
      activeSkus: '启用 SKU',
      pendingReview: '待审核',
      lastImport: '最近导入',
      suggestionsNeedReview: '条产品客服建议需要审核。',
      suggestionNeedsReview: '条产品客服建议需要审核。',
      reviewSuggestions: '审核建议',
      productsTab: '产品',
      importsTab: '导入记录',
      supportQaTab: '客服 QA',
      search: '搜索',
      searchPlaceholder: 'SKU、ASIN 或标题',
      searchProducts: '搜索产品',
      status: '状态',
      all: '全部',
      active: '启用',
      inactive: '停用',
      type: '类型',
      allTypes: '全部类型',
      platform: '平台',
      title: '标题',
      updated: '更新时间',
      details: '详情',
      open: '打开',
      noProducts: '暂无产品。',
      showing: '显示',
      of: '/',
      rows: '每页行数',
      previous: '上一页',
      next: '下一页',
      page: '页码',
      noPreview: '尚未选择导入预览。',
      noPreviewHelp: '使用页面顶部的“上传产品文件”预览工作簿变更，确认后再应用。',
      importHistory: '导入历史',
      noImports: '暂无导入记录。',
      supportReview: '客服 QA 审核',
      supportReviewHelp: '在这里审核客服表达；产品事实继续由结构化产品工具管理。',
      qaSearchPlaceholder: 'SKU、产品系列或答案内容',
      searchSuggestions: '搜索 QA 建议',
      productFamily: '产品 / 系列',
      intent: '意图',
      risk: '风险',
      proposedAnswer: '建议答案',
      evidence: '证据',
      actions: '操作',
      noSuggestions: '当前视图中没有 QA 建议。',
      uploadTitle: '上传产品文件',
      uploadDescription: '上传 Bizsprite Product Info 工作簿以预览变更。Product_Master 为必需，其他支持工作表可以留空。审核差异并选择应用导入前，不会写入任何变更。',
      workbook: '工作簿',
      workbookHelp: '只接受 .xlsx 格式。可下载 Bizsprite 空白模板，或导出当前数据后编辑。',
      chooseWorkbook: '选择工作簿',
      fieldDictionary: '字段说明',
      uploadedColumn: '上传列',
      productField: '产品字段',
      usedFor: '用途',
      aiFact: 'AI 可用事实',
      cancel: '取消',
      generateTitle: '生成建议',
      generateDescription: '根据近期客户证据和最近变更的产品生成客服 QA 建议。建议在批准前一直保持待审核状态。',
      generateBoundary: '产品事实保留在 Product Info 中；这里只生成客服表达。',
      advanced: '高级工具',
      generate: '生成',
      advancedTitle: '高级产品 QA 工具',
      advancedBoundary: '高级工具用于受控审核、排障和批量管理；建议仍需批准后才能应用。',
      generateByScope: '按范围生成',
      selectedSkus: '指定 SKU',
      selectedSkusPlaceholder: '使用逗号或空格分隔 SKU',
      chooseFamily: '选择产品系列',
      reviewFilters: '审核筛选',
      reviewFiltersHelp: '审核特定任务、意图、风险或产品系列时使用筛选条件。',
      reviewJob: '审核任务',
      allJobs: '全部任务',
      pending: '待处理',
      approved: '已批准',
      rejected: '已拒绝',
      action: '操作类型',
      allActions: '全部操作',
      create: '新建',
      update: '更新',
      deactivate: '停用',
      keep: '保留',
      conflict: '冲突',
      category: '分类',
      allCategories: '全部分类',
      allIntents: '全部意图',
      allRisk: '全部风险',
      high: '高',
      medium: '中',
      low: '低',
      recentEvidence: '近期证据',
      query: '查询内容',
      failure: '失败原因',
      noEvidence: '尚未加载证据。',
      productFamilies: '产品系列',
      family: '系列',
      skus: 'SKU',
      noFamilies: '尚未加载产品系列。',
      close: '关闭',
      noSourceColumns: '没有可用的来源列。',
      sourceColumn: '来源列',
      uploadedValue: '上传值',
      noRawColumns: '没有原始列',
      noBucketRows: '此分类中没有数据。',
      sku: 'SKU',
      asin: 'ASIN',
      product: '产品',
      productType: '产品类型',
      yes: '是',
      no: '否',
      diffNew: '新增',
      diffChanged: '变更',
      diffWillDeactivate: '将停用',
      invalid: '无效',
      invalidLower: '条无效',
      showingFirst: '显示前',
      sourceColumnsLower: '个来源列',
      rowsLower: '行',
      evidenceItem: '条证据',
      evidenceItems: '条证据',
      merged: '已合并',
      requiredProductKey: '必需的产品键',
      amazonLookupKey: 'Amazon 查询键',
      productNameUse: '用于搜索和客服回答的产品名称',
      brandFactUse: '用于产品目录回答的品牌事实',
      catalogGroupingUse: '产品目录分组和筛选',
      listingClaimsUse: '商品卖点和客服表达',
      searchHintsUse: '搜索提示',
      productSpecsUse: '产品规格',
      priceReferenceOnly: '仅在 v1 中作为参考',
      compatibilityShippingUse: '兼容性和配送支持',
      auditFutureMappingUse: '保留用于审计和未来字段映射',
      intentCompatibility: '兼容性',
      intentDimensions: '适配 / 尺寸',
      intentPurchase: '购买指导',
      intentVariant: '款式选择',
      intentWarranty: '保修',
      intentAfterSales: '售后',
      intentUnknown: '未知 / 转交',
      categoryCompatibility: '兼容性判断',
      categoryDimensions: '适配与尺寸',
      categoryPurchase: '购买指导',
      categoryVariant: '款式选择',
      categoryWarranty: '保修政策',
      categoryAfterSales: '售后分类',
      categoryUnknown: '未知 / 转交',
      allActiveScanEstimate: '全部启用产品扫描估算',
      activeProductsBatchHelp: '个启用产品。请按所选 SKU 分批生成建议。',
      newEvidenceItemCollected: '条新证据已收集。',
      newEvidenceItemsCollected: '条新证据已收集。',
      applyImport: '应用导入',
      invalidRowsHelp: '无效行已显示在下方。请上传修正后的工作簿再应用。',
      willDeactivateHelp: '“将停用”中的行是当前启用但未出现在本工作簿中的 SKU，应用后会标记为停用。',
      unchangedSkusHidden: '个未变更 SKU 已从审核标签页隐藏。',
      importLabel: '导入',
      warningLabel: '警告',
      viewDiff: '查看差异',
      unmappedSourceColumns: '未映射的来源列',
      pendingAgentSuggestions: '待审核的 QA Agent 建议',
      deactivateConfirm: '个现有 SKU 将被标记为停用。是否应用此导入？',
      applyBulkPrefix: '是否对当前筛选批次执行',
      applyBulkSuffix: '？每次最多影响一个后端批次。',
      generateSuggestions: '生成建议',
      applyApproved: '应用已批准建议',
      selected: '项已选择',
      approveSelected: '批准所选项',
      rejectSelected: '拒绝所选项',
      approve: '批准',
      reject: '拒绝',
      suggestionsLower: '条建议',
      collectEvidence: '收集证据',
      refreshFamilies: '刷新产品系列',
      changedProducts: '已变更产品',
      failedSearches: '失败搜索',
      selectedFamily: '所选产品系列',
      suggestionsUpdated: '条建议已更新。',
      appliedCount: '条已应用',
      approvedRemain: '条已批准建议留待下一批处理。',
      importStatuses: {
        uploaded: '已上传', previewed: '已预览', ready: '就绪',
        applied: '已应用', failed: '失败', pending: '待处理',
      },
      jobStatuses: {
        pending: '待处理', running: '运行中', completed: '已完成',
        failed: '失败', approved: '已批准', rejected: '已拒绝',
      },
      brand: '品牌',
      price: '价格',
      changeReason: '变更原因',
      sourceColumns: '来源列',
      reason: '原因',
      overview: '概览',
      listingFields: '商品字段',
      dimensions: '尺寸',
      compatibility: '兼容性',
      faq: '常见问题',
      afterSales: '售后',
      rawSource: '原始来源',
      approvedLink: '已批准产品链接',
      openApprovedLink: '打开已批准链接',
      missingApprovedLink: '缺少已批准产品链接。Voice 和 SMS 必须停止发送，不能根据 ASIN 或其他产品数据自行构造 URL。',
      parentAsin: '父 ASIN',
      salesChannel: '销售渠道',
      source: '来源',
      material: '材质',
      color: '颜色',
      warranty: '保修',
      itemSize: '商品尺寸',
      itemWeight: '商品重量',
      packageSize: '包装尺寸',
      packageWeight: '包装重量',
      qaAgent: 'QA Agent',
      manual: '人工维护',
      description: '描述',
      bulletPoints: '要点',
      keywords: '关键词',
      dimensionColumns: '尺寸来源列',
      noCompatibility: '暂无产品专属兼容性规则。',
      noFaq: '暂无产品专属 FAQ。',
      noAfterSales: '暂无售后规则。',
      productsCovered: '已覆盖产品',
      needsAttention: '需要处理',
      selectSuggestionPage: '选择当前页 QA 建议',
      selectSuggestion: '选择 QA 建议',
      noFamily: '未归入系列',
      showFilters: '显示筛选',
      hideFilters: '隐藏筛选',
      loadProductsFailed: '加载产品失败',
      previewReady: '导入预览已就绪',
      uploadFailed: '上传失败',
      templateDownloaded: '产品模板已下载',
      downloadFailed: '下载失败',
      dataExported: '当前产品数据已导出',
      exportFailed: '导出失败',
      resolveInvalid: '请先处理无效数据行',
      correctWorkbook: '请上传修正后的工作簿，再应用此导入。',
      importAppliedReview: '导入已应用，可以开始 QA 审核',
      importApplied: '导入已应用',
      applyFailed: '应用失败',
      enterSku: '请至少输入一个 SKU',
      tooManySkus: 'SKU 数量过多',
      maxSkus: '每次 QA Agent 扫描最多处理 50 个 SKU。',
      chooseProductFamily: '请选择产品系列',
      scanReady: 'QA Agent 扫描已可审核',
      scanFailed: 'QA Agent 扫描失败',
      suggestionsReady: '建议已可审核',
      generateFailed: '生成建议失败',
      evidenceCollected: '证据收集完成',
      evidenceFailed: '证据收集失败',
      familiesRefreshed: '产品系列已刷新',
      familyRefreshFailed: '刷新产品系列失败',
      selectSuggestions: '请先选择建议',
      suggestionsApproved: '建议已批准',
      suggestionsRejected: '建议已拒绝',
      bulkUpdateFailed: '批量更新失败',
      suggestionApproved: '建议已批准',
      suggestionRejected: '建议已拒绝',
      suggestionUpdateFailed: '更新建议失败',
      noQaJob: '没有可用的 QA 任务',
      approvedApplied: '已批准 FAQ 建议已应用',
      approvedApplyFailed: '应用已批准建议失败',
      loadProductFailed: '加载产品详情失败',
    },
    extensions: {
      helpTitle: '分机管理',
      helpDescription: '查看 AI 分机是否在运行，并可启动、停止或重启。',
      start: '启动',
      startHelp: '启动这个分机的 AI 程序。显示“运行中”后，请拨打一次确认能接通。',
      stop: '停止',
      stopHelp: '停止这个分机的 AI 程序。操作前请确认当前没有进行中的通话。',
      restart: '重启',
      restartHelp: '先停止再启动 AI 程序。账号或线路配置有问题时，重启解决不了。',
      refreshStatus: '刷新状态',
      refreshHelp: '只更新本页显示的状态，不会重启分机。',
      runtimeWarning: '“运行中”只说明分机的 AI 程序已启动，不保证一定能接通电话，请以实际拨打为准。“刷新状态”只更新本页显示，不会重启分机。',
      total: '总数',
      running: '运行中',
      stopped: '已停止',
      transitioning: '状态切换中',
      parked: '注册失败·待处理',
      error: '错误',
      unknown: '未知',
      extensions: '分机',
      extensionDomain: '分机 / 域名',
      concurrentCalls: '并发通话数',
      concurrentCallsHint: '在 OneSuite Business 后台修改',
      status: '状态',
      runtime: '运行方式',
      actions: '操作',
      alwaysOn: '启动后全天运行',
      noExtensions: '当前没有可用分机。',
      notAvailable: '不适用',
      startTitle: '启动这个分机的 AI 程序；能否接通请拨打确认。',
      stopTitle: '停止这个分机的 AI 程序；操作前请确认没有进行中的通话。',
      restartTitle: '先停止再启动这个分机的 AI 程序。',
      loadFailed: '加载分机失败',
      statusFailed: '获取分机状态失败',
      pleaseWait: '请稍候',
      pleaseWaitDetail: '请稍候片刻再执行其他操作',
      extension: '分机',
      started: '已启动',
      stoppedAction: '已停止',
      restarted: '已重启',
      startFailed: '启动失败',
      stopFailed: '停止失败',
      restartFailed: '重启失败',
    },
    callHistory: {
      helpTitle: '通话记录',
      helpDescription: '查看各分机最近处理的通话，并打开完整通话详情。',
      pickExtension: '选择分机',
      pickExtensionDetail: '从下拉菜单选择 AI 分机，只查看该号码的通话记录。',
      scanStatus: '查看状态和结束原因',
      scanStatusDetail: '状态标签区分已完成、失败和处理中；可将鼠标停留在结束原因上查看完整内容。',
      openDetails: '打开详情',
      openDetailsDetail: '点击“查看详情”，打开完整转录文本和通话处理信息。',
      pageTitle: '通话记录',
      refresh: '刷新',
      recentCalls: '最近通话',
      extension: '分机',
      monitoring: '查看 AI 分机活动',
      status: '状态',
      caller: '来电号码',
      time: '时间',
      duration: '时长',
      reason: '结束原因',
      actions: '操作',
      noRecords: '未找到通话记录。',
      viewDetails: '查看详情',
      loadError: '加载数据失败',
      callsLoadFailed: '加载通话记录失败',
      completed: '已完成',
      failed: '失败',
      inProgress: '处理中',
    },
    callDetail: {
      helpTitle: '通话详情',
      helpDescription: '核查单次通话：来电方、通话时长以及保存的录音。',
      reviewSummary: '查看摘要',
      reviewSummaryDetail: '先查看来电号码、开始时间、时长、状态和结束原因。',
      listenRecording: '听取录音',
      listenRecordingDetail: '以音频播放器中的完整录音作为通话事实依据。',
      generateTranscript: '生成转录文本',
      generateTranscriptDetail: '仅在需要文字时使用“转录”；它会在通话结束后处理完整录音。',
      back: '返回通话记录',
      pageTitle: '通话详情',
      id: 'ID',
      exportJson: '导出 JSON',
      summary: '摘要',
      caller: '来电号码',
      startTime: '开始时间',
      duration: '时长',
      status: '状态',
      endReason: '结束原因',
      recording: '通话录音',
      noRecording: '本次通话没有可用录音。',
      loadingRecording: '正在加载录音……',
      transcribe: '转录',
      transcribing: '正在转录',
      download: '下载',
      transcribingDetail: '正在转录完整录音。完成后，转录文本会显示在下方。',
      recordingMetadataOnly: '系统中有录音元数据，但没有返回可播放的录音地址。',
      transcript: '对话转录文本',
      hide: '隐藏',
      show: '显示',
      toolMessages: '工具消息',
      noSavedTranscript: '没有已保存的转录文本。请使用上方“转录”，从录音生成文本。',
      recordingStatusFirst: '没有可用转录文本，但存在录音元数据。尝试转录前，请先检查上方录音状态。',
      noTranscript: '本次通话没有可用转录文本。',
      tenantRequired: '需要租户上下文',
      tenantRequiredDetail: '请登录或选择一个租户。',
      callNotFound: '未找到通话',
      detailsLoadError: '加载通话详情失败',
      recordingLoadFailed: '加载录音失败',
      transcriptLoaded: '转录文本已加载',
      transcriptGenerated: '转录文本已生成',
      transcriptionFailed: '转录失败',
      transcriptionUnavailable: '无法转录该录音。',
      completed: '已完成',
      failed: '失败',
    },
    sms: {
      helpTitle: '短信',
      helpDescription: '查看当前账号记录的交易类外发短信活动。',
      reviewActivity: '查看短信活动',
      reviewActivityDetail: '查看已记录的收件号码、短信类型、时间和服务商状态。',
      filterSearch: '筛选和搜索',
      filterSearchDetail: '按记录状态或短信类型筛选，也可搜索当前已加载的活动。',
      interpretStatus: '正确理解状态',
      interpretStatusDetail: '“已提交”表示服务商接受了发送请求；只有“已送达”表示收到了送达回执。',
      pageTitle: '短信',
      pageSummary: '当前账号记录的真实外发短信活动',
      recorded: '已记录',
      inProgress: '处理中',
      delivered: '已送达',
      failed: '失败',
      searchPlaceholder: '搜索号码、内容或参考编号……',
      allStatuses: '全部状态',
      providerAccepted: '服务商已接受',
      submittedLegacy: '已提交（旧状态）',
      submitted: '已提交',
      undeliverable: '无法送达',
      expired: '已过期',
      pending: '等待中',
      queued: '排队中',
      allTypes: '全部类型',
      infoLink: '信息链接',
      notification: '通知',
      verification: '验证',
      callback: '回拨',
      booking: '预约',
      general: '一般信息',
      productLink: '商品链接',
      ticketForm: '工单表单',
      ticketUpdate: '工单通知',
      help: '帮助',
      created: '已创建',
      processing: '发送处理中',
      suppressed: '已阻止',
      resultUnconfirmed: '发送结果待确认',
      destination: '收件号码',
      message: '短信内容',
      type: '类型',
      status: '状态',
      activityTime: '活动时间',
      loading: '正在加载短信活动……',
      noActivity: '未找到短信活动。',
      unknown: '未知',
      errorInfo: '错误信息',
      records: '条记录',
      page: '第',
      of: '页，共',
      previous: '上一页',
      next: '下一页',
      loadFailed: '无法加载短信活动',
      loadFailedDetail: '请重试；如果问题持续，请联系支持人员。',
      inboxTitle: '客户来信',
      inboxSummary: '客户发到短信号码、但不是回复工单或回电请求的短信。请根据您自己的记录跟进。',
      inboxFromHistory: '近期联系过',
      inboxFromHistoryDetail: '这个号码最近给您打过电话、和您互发过短信，或提交过回电请求。',
      inboxAssigned: '客服转交',
      inboxAssignedDetail: 'Aiker 客服把这条短信转交给了您的账号。',
      inboxFrom: '发信号码',
      inboxReceived: '收到时间',
      inboxMarkHandled: '标记已处理',
      inboxReopen: '重新打开',
      inboxShowHandled: '显示已处理',
      inboxHandled: '已处理',
      inboxLoadFailed: '无法加载客户来信',
      inboxUpdateFailed: '无法更新这条短信',
    },
    contacts: {
      pageTitle: '联系人',
      pageSummary: '管理联系人目录、路由别名和转接目标',
      addContact: '添加联系人',
      csvMaintenance: 'CSV 维护',
      search: '搜索',
      searchPlaceholder: '搜索姓名、别名、分机或电话……',
      status: '状态',
      allStatuses: '全部状态',
      active: '在用',
      inactive: '停用',
      onLeave: '休假中',
      prospect: '潜在客户',
      contacts: '位联系人',
      noMatches: '没有符合当前筛选条件的联系人。',
      page: '第',
      of: '页，共',
      previous: '上一页',
      next: '下一页',
      employee: '员工',
      department: '部门',
      queue: '队列',
      client: '客户',
      visitor: '访客',
      editContact: '编辑联系人',
      new: '新建',
      formSummary: '联系人目录记录及路由行为',
      routingIdentity: '路由身份',
      name: '姓名',
      fullNamePlaceholder: '完整姓名……',
      otherNames: '其他名称',
      aliasesPlaceholder: '填写来电方可能说出的别名，用逗号或换行分隔……',
      extensionNumber: '分机号码',
      contactType: '联系人类型',
      contactDetails: '联系方式',
      phoneNumber: '电话号码',
      email: '电子邮箱',
      notes: '备注',
      notesPlaceholder: '内部备注……',
      runtimeBehavior: '运行行为',
      supportsConsultation: '支持咨询式转接',
      voicemailEnabled: '启用语音信箱',
      voicemailManagedExternally: '语音信箱由电话供应商 / PBX 管理。请联系电话管理员确认收听入口和方法。',
      operatorAnyTransfer: '总机——可接收任意转接',
      cancel: '取消',
      saveContact: '保存联系人',
      positionTitle: '职位 / 头衔',
      companyName: '公司名称',
      industry: '行业',
      tier: '级别',
      standard: '标准',
      vip: 'VIP',
      partner: '合作伙伴',
      serviceType: '服务类型',
      contractExpiry: '合同到期日',
      activeTransferTarget: '在用——显示为转接目标',
      inactiveHidden: '停用——不参与路由',
      activeTransfers: '在用——可以接收转接',
      leaveUnavailable: '休假中——暂时不可用',
      inactiveNotOffered: '停用——不作为转接目标',
      nameRequired: '必须填写姓名',
      extensionRequired: '转接目标必须填写分机号码',
      phoneOrExtensionRequired: '请填写电话号码或分机号码',
      departmentPlaceholder: '例如：工程部',
      positionPlaceholder: '例如：高级开发工程师',
      companyPlaceholder: '例如：示例公司',
      industryPlaceholder: '例如：科技',
      supplierPlaceholder: '供应商公司名称',
      servicePlaceholder: '例如：办公用品、IT 服务',
      emailPlaceholder: 'name@example.com',
      noAliases: '没有别名',
      extension: '分机',
      phone: '电话',
      transfer: '转接方式',
      consultationTransfer: '咨询式转接',
      blindTransferOnly: '仅盲转',
      consultation: '咨询式',
      blindOnly: '仅盲转',
      flags: '标记',
      voicemail: '语音信箱',
      operator: '总机',
      edit: '编辑联系人',
      delete: '删除联系人',
      loadFailed: '加载联系人失败',
      deleted: '联系人已删除',
      deleteFailed: '删除失败',
      updated: '联系人已更新',
      created: '联系人已创建',
      saveFailed: '保存失败',
      csvDescription: '下载标准联系人模板，填写或修改后上传。匹配到的联系人会被更新，新数据行会创建联系人。',
      acceptedFormats: '支持的格式',
      acceptedFormatsDetail: '支持 CSV、XLSX 或 XLS。必填列：name。分机、部门、转接设置和备注为选填项。',
      downloadTemplate: '下载模板',
      downloadCurrent: '下载当前联系人',
      uploadFile: '上传文件',
      close: '关闭',
      deleteTitle: '删除联系人',
      deleteConfirmPrefix: '确定要删除',
      deleteConfirmSuffix: '此操作无法撤销。',
      deleteAction: '删除',
      unknown: '未知',
      validationIssues: '发现数据校验问题',
      importSkipped: '已跳过导入',
      importSkippedDetail: '没有可导入的有效数据行。请修正错误后重试。',
      importFinished: '导入完成',
      uploadFailed: '上传失败',
      noRows: '文件中没有数据行',
      rowsHaveErrors: '行存在错误。',
      validRowsImported: '行有效，将被导入。',
      imported: '已导入',
      failedCount: '失败',
      skippedRows: '行已跳过（请查看错误报告）。',
      invalidContactType: 'contact_type 无效；可用值为：',
      invalidExtension: '分机只能包含字母、数字或连字符',
      duplicateExtension: '文件中存在重复分机',
      invalidPhone: '电话号码包含无效字符',
    },
    supportTickets: {
      pageTitle: '工单中心',
      pageSummary: '跟踪回拨、产品问题、退货、换货及人工跟进',
      createTicket: '创建工单',
      createTicketHelp: '记录客户姓名、电话、类型、摘要、优先级以及可选的产品或订单背景。',
      filterSearch: '筛选和搜索',
      filterSearchHelp: '按状态、类型、优先级筛选并搜索需要回拨或支持跟进的工作。',
      closeLoop: '完成跟进闭环',
      closeLoopHelp: '跟进后将工单标记为“已联系”或“已完成”；不再需要处理时标记为“已取消”。',
      refresh: '刷新',
      newTicket: '新建工单',
      searchPlaceholder: '搜索客户、QA ID、分类、问题、产品、订单或 AI 摘要……',
      allStatus: '全部状态',
      allTypes: '全部类型',
      allPriority: '全部优先级',
      pending: '待处理',
      contacted: '已联系',
      completed: '已完成',
      cancelled: '已取消',
      urgent: '紧急',
      high: '高',
      normal: '普通',
      low: '低',
      callback: '回拨',
      emailBack: '邮件回复',
      ecommerceSupport: '电商支持工单',
      compatibilityReview: '兼容性审核',
      returnRefund: '退货 / 退款',
      replacement: '换货',
      missingItem: '缺少商品',
      damagedItem: '商品损坏',
      bulkPurchase: '批量采购',
      invoiceRequest: '发票申请',
      humanEscalation: '转人工处理',
      other: '其他',
      departmentNotConfigured: '部门尚未配置',
      transferFailed: '转接失败',
      noTransferTarget: '没有转接目标',
      callbackRequested: '客户要求回拨',
      productQuestion: '产品问题',
      returnOrRefund: '退货或退款',
      missingItemIssue: '缺少商品',
      damagedItemIssue: '商品损坏',
      departmentRoutingMissing: '尚未配置部门路由',
      transferTargetNotFound: '未找到转接目标',
      transferUnavailable: '转接目标当前不可用',
      noDepartmentMatch: '未找到匹配的部门',
      noContactMatch: '未找到匹配的联系人',
      markContacted: '标记为已联系',
      markCompleted: '标记为已完成',
      clear: '清除选择',
      selectAll: '全选',
      selectTicket: '选择工单：',
      type: '类型',
      customer: '客户',
      issueSummary: '问题 / 摘要',
      priority: '优先级',
      status: '状态',
      created: '创建时间',
      actions: '操作',
      loading: '正在加载……',
      noTickets: '暂无支持工单（按最新优先显示）。',
      unknownCustomer: '未知客户',
      followUpRequested: '需要支持人员跟进',
      target: '目标',
      needsSetup: '需要配置',
      markDone: '标记完成',
      options: '更多操作',
      viewDetails: '查看详情',
      call: '拨打电话',
      cancel: '取消',
      page: '第',
      upTo: '每页最多',
      perPageNewest: '条，最新优先',
      perPageOldest: '条，最早优先',
      previous: '上一页',
      next: '下一页',
      newTicketTitle: '新建支持工单',
      customerName: '客户姓名',
      customerNamePlaceholder: '例如：张三',
      phoneNumber: '电话号码',
      customerEmail: '客户邮箱',
      platform: '平台',
      platformPlaceholder: 'Amazon / 官网 / 电话',
      orderNumber: '订单号',
      product: '产品',
      issueType: '问题类型',
      requestedAction: '期望处理方式',
      create: '创建',
      optional: '选填',
      productPlaceholder: '产品名称或 SKU',
      issueTypePlaceholder: '适配、退货、缺少商品等……',
      actionPlaceholder: '审核兼容性、回拨、换货等……',
      summaryPlaceholder: '客户问题、故障及相关背景',
      error: '错误',
      success: '成功',
      nameNumberRequired: '必须填写客户姓名和电话号码',
      emailRequired: '邮件回复工单必须填写客户邮箱',
      ticketCreated: '支持工单已创建',
      createFailed: '创建支持工单失败',
      loadFailed: '加载支持工单失败',
      updated: '已更新',
      requestMarked: '工单状态已标记为',
      updateFailed: '更新状态失败',
      bulkUpdate: '批量更新',
      updatedCount: '条已更新',
      failedCount: '条失败',
      none: '无',
      ticketDetails: '工单详情',
      unknown: '未知',
      noPhone: '无电话',
      email: '邮箱',
      notAvailable: '不适用',
      noSummary: '无摘要',
      context: '业务背景',
      order: '订单',
      device: '设备',
      handling: '处理信息',
      category: '分类',
      urgency: '紧急程度',
      requiredFields: '必填字段',
      collectedFields: '已收集字段',
      aiSummary: 'AI 摘要',
      close: '关闭',
    },
  },
};

export const getPortalPageCopy = (lang, page) => (
  portalPageCopy[lang]?.[page] || portalPageCopy.en[page]
);
